/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from "react";
import {
  Form,
  Input,
  Table,
  Modal,
  Select,
  Button,
  Space,
  DatePicker,
  Cascader,
  Radio,
  Checkbox,
  Tabs,
  Divider,
} from "antd";
import moment from "moment";
import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";
import Api from "../../services/ServiceApi";
import DynamicTable from "../../services/ui/dynamic_table";
import Cookies from "js-cookie";
const { Option } = Select;
const { TabPane } = Tabs;
// function onChange(e) {
//   console.log(`checked = ${e.target.checked}`);
// }

class DynamicList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      active: 0,
      data: [],
      visible: false,
      visibleView: false,
      visibleConfig: false,
      showApiConfigModal: false,
      showSelectConfigModal: false,
      showCheckboxConfigModal: false,
      showRadioConfigModal: false,
      showTextinputConfigModal: false,
      showPasswordinputConfigModal: false,
      showDateinputConfigModal: false,
      showDateTimeinputConfigModal: false,
      showEmailinputConfigModal: false,
      showMonthinputConfigModal: false,
      showNumberinputConfigModal: false,
      showRangeinputConfigModal: false,
      showPhoneNumberinputConfigModal: false,
      showTimeinputConfigModal: false,
      showUrlinputConfigModal: false,
      showWeekinputConfigModal: false,
      showTextAreainputConfigModal: false,
      value: 1,
      dataModuleName: [],
      valueModuleName: "",
      dataCompanyName: [
        { value: "1", text: "Plan B" },
        { value: "2", text: "UIH" },
      ],
      valueCompanyName: "",
      dataTableName: [],
      config: [{ id: 0, value: false }],
      configCol: [{ key: "EN", text: "" }],
      count_component: [],
      count_form: 0,
      count_modal: 0,
      valueTableName: "",
      dataMasterLanguage: [],
      dataGenTable: [],
      flag_table: 0,
      flag_output: 0,
      valueMasterLanguage: [
        { children: ["English", " (", "EN", ")"], key: "EN", value: "English" },
      ],
      lang: "EN",
      testJSON: [
        {
          label: {
            EN: {
              for: "la_en1",
              text: "la_en1",
              width: 12,
            },
            TH: {
              for: "la_en1",
              text: "la_th1",
              width: 12,
            },
            CSS: {},
          },
          table: {
            EN: {
              columns: [
                {
                  key: "co_en11",
                  title: "co_en11",
                  dataIndex: "co_en11",
                },
              ],
            },
            TH: {
              columns: [
                {
                  key: "co_th11",
                  title: "co_th11",
                  dataIndex: "co_th11",
                },
              ],
            },
            CSS: {},
          },
        },
        {
          label: {
            EN: {
              for: "la_en2",
              text: "la_en2",
              width: 12,
            },
            TH: {
              for: "la_en2",
              text: "la_th2",
              width: 12,
            },
            CSS: {},
          },
          table: {
            EN: {
              columns: [
                {
                  key: "co_en21",
                  title: "co_en21",
                  dataIndex: "co_en21",
                },
              ],
            },
            TH: {
              columns: [
                {
                  key: "co_th21",
                  title: "co_th21",
                  dataIndex: "co_th21",
                },
              ],
            },
            CSS: {},
          },
        },
      ],

      /*testJSON : [{
        "label": {
          "EN": {
            "for": "description_impact",
            "text": "Description Impact",
            "width": "12"
          },
          "TH": {
            "for": "description_impact",
            "text": "รายละเอียด Impact",
            "width": "12"
          },
          "CSS": {
            "color": "darkblue",
            "marginTop": "30",
            "textAlign": "right",
            "marginBottom": "10",
            "backgroundColor": "#fff"
          }
        }
      }, {
        "table": {
          "EN": {
            "columns": [{
              "key": "sysTime",
              "title": "Sys_Time",
              "dataIndex": "sysTime"
            }, {
              "key": "insTime",
              "title": "Ins_Time",
              "dataIndex": "insTime"
            }, {
              "key": "nodeID",
              "title": "Node_ID",
              "dataIndex": "nodeID"
            }, {
              "key": "TrunkID",
              "title": "Trunk_ID",
              "dataIndex": "TrunkID"
            }, {
              "key": "TrunkName",
              "title": "Trunk_Name",
              "dataIndex": "TrunkName"
            }, {
              "key": "CustID",
              "title": "Cust_ID",
              "dataIndex": "CustID"
            }, {
              "key": "NMCCID",
              "title": "NMC_CID",
              "dataIndex": "NMCCID"
            }, {
              "key": "CircuitName",
              "title": "Circuit_Name",
              "dataIndex": "CircuitName"
            }, {
              "key": "S",
              "title": "S",
              "dataIndex": "S"
            }, {
              "key": "U",
              "title": "U",
              "dataIndex": "U"
            }, {
              "key": "IF",
              "title": "IF",
              "dataIndex": "IF"
            }, {
              "key": "CardType",
              "title": "Card_Type",
              "dataIndex": "CardType"
            }, {
              "key": "Alarm",
              "title": "Alarm",
              "dataIndex": "Alarm"
            }],
            "datasource": []
          },
          "TH": {
            "columns": [{
              "key": "sysTime",
              "title": "เวลาระบบ",
              "dataIndex": "sysTime"
            }, {
              "key": "insTime",
              "title": "Ins_Time",
              "dataIndex": "insTime"
            }, {
              "key": "nodeID",
              "title": "ไอดี node",
              "dataIndex": "nodeID"
            }, {
              "key": "TrunkID",
              "title": "ไอดี Trunk",
              "dataIndex": "TrunkID"
            }, {
              "key": "TrunkName",
              "title": "ชื่อ Trunk",
              "dataIndex": "TrunkName"
            }, {
              "key": "CustID",
              "title": "รหัสลูกค้า",
              "dataIndex": "CustID"
            }, {
              "key": "NMCCID",
              "title": "NMC_CID",
              "dataIndex": "NMCCID"
            }, {
              "key": "CircuitName",
              "title": "ชื่อ Circuit",
              "dataIndex": "CircuitName"
            }, {
              "key": "S",
              "title": "S",
              "dataIndex": "S"
            }, {
              "key": "U",
              "title": "U",
              "dataIndex": "U"
            }, {
              "key": "IF",
              "title": "IF",
              "dataIndex": "IF"
            }, {
              "key": "CardType",
              "title": "Card_Type",
              "dataIndex": "CardType"
            }, {
              "key": "Alarm",
              "title": "Alarm",
              "dataIndex": "Alarm"
            }],
            "datasource": []
          },
          "CSS": {}
        }
      },
      {
        "label": {
          "EN": {
            "for": "table2",
            "text": "table2",
            "width": 12
          },
          "TH": {
            "for": "table2",
            "text": "ตารางที่ 2",
            "width": 12
          },
          "CSS": {
            "color": "white",
            "marginTop": "30",
            "textAlign": "right",
            "marginBottom": "10",
            "backgroundColor": "#00f"
          }
        }
      }, {
        "table": {
          "EN": {
            "columns": [{
              "key": "sysTime",
              "title": "Sys_Time",
              "dataIndex": "sysTime"
            }, {
              "key": "insTime",
              "title": "Ins_Time",
              "dataIndex": "insTime"
            }, {
              "key": "nodeID",
              "title": "Node_ID",
              "dataIndex": "nodeID"
            }, {
              "key": "TrunkID",
              "title": "Trunk_ID",
              "dataIndex": "TrunkID"
            }, {
              "key": "TrunkName",
              "title": "Trunk_Name",
              "dataIndex": "TrunkName"
            }, {
              "key": "CustID",
              "title": "Cust_ID",
              "dataIndex": "CustID"
            }, {
              "key": "NMCCID",
              "title": "NMC_CID",
              "dataIndex": "NMCCID"
            }, {
              "key": "CircuitName",
              "title": "Circuit_Name",
              "dataIndex": "CircuitName"
            }, {
              "key": "CardType",
              "title": "Card_Type",
              "dataIndex": "CardType"
            }, {
              "key": "Alarm",
              "title": "Alarm",
              "dataIndex": "Alarm"
            }],
            "datasource": []
          },
          "TH": {
            "columns": [{
              "key": "sysTime",
              "title": "เวลาระบบ",
              "dataIndex": "sysTime"
            }, {
              "key": "insTime",
              "title": "Ins_Time",
              "dataIndex": "insTime"
            }, {
              "key": "nodeID",
              "title": "ไอดี node",
              "dataIndex": "nodeID"
            }, {
              "key": "TrunkID",
              "title": "ไอดี Trunk",
              "dataIndex": "TrunkID"
            }, {
              "key": "TrunkName",
              "title": "ชื่อ Trunk",
              "dataIndex": "TrunkName"
            }, {
              "key": "CustID",
              "title": "รหัสลูกค้า",
              "dataIndex": "CustID"
            }, {
              "key": "NMCCID",
              "title": "NMC_CID",
              "dataIndex": "NMCCID"
            }, {
              "key": "CircuitName",
              "title": "ชื่อ Circuit",
              "dataIndex": "CircuitName"
            }, {
              "key": "CardType",
              "title": "Card_Type",
              "dataIndex": "CardType"
            }, {
              "key": "Alarm",
              "title": "Alarm",
              "dataIndex": "Alarm"
            }],
            "datasource": []
          },
          "CSS": {}
        }
      }
    ],*/

      columns: [
        {
          title: "Company Name",
          dataIndex: "company_id",
          key: "company_id",
          sorter: (a, b) => b.company_id - a.company_id,
          render: (text, record, index) => {
            let comp_name = "";
            if (text === 1) {
              comp_name = "Plan B";
            } else if (text === 2) {
              comp_name = "UIH";
            }
            return comp_name;
          },
        },
        {
          title: "Module Name",
          dataIndex: "module_name",
          key: "module_name",
          sorter: (a, b) => b.module_name.length - a.module_name.length,
        },
        {
          title: "Table Name",
          dataIndex: "table_name",
          key: "table_name",
          sorter: (a, b) => b.table_name.length - a.table_name.length,
        },
        {
          title: "Condition",
          dataIndex: "data_roles",
          key: "data_roles",
          sorter: (a, b) => a.data_roles.length - b.data_roles.length,
        },
        {
          title: "Effective date",
          dataIndex: "effective_date",
          key: "effective_date",
          sorter: (a, b) => a.effective_date.length - b.effective_date.length,
        },
        {
          title: "Expire date",
          dataIndex: "expire_date",
          key: "expire_date",
          sorter: (a, b) => a.expire_date.length - b.expire_date.length,
          render: (text, record, index) => {
            let expire_date = "";
            if (text !== "" && text !== null) {
              expire_date = moment(text, "YYYY/MM/DD").format("DD/MM/YYYY");
            }
            return expire_date;
          },
        },
        {
          title: "Update date",
          dataIndex: "update_date",
          key: "update_date",
          sorter: () => null,
        },
        {
          title: "Action",
          dataIndex: "key",
          key: "key",
          sorter: () => null,
          render: (text, record, index) => (
            <div>
              <a href="#" onClick={() => this.onModalView(text, true)}>
                <img src={Api.absoluteUrl("/icon/view.svg")} />
              </a>
              <a href="#" onClick={() => this.onModal(text, "edit", true)}>
                <img src={Api.absoluteUrl("/icon/edit.svg")} />
              </a>
            </div>
          ),
        },
      ],
      typeOpt: [
        {
          value: "input",
          label: "Input",
          children: [
            {
              value: "text",
              label: "Text",
              children: [
                { value: "", label: "No Required" },
                { value: "required", label: "Required" },
              ],
            },
            {
              value: "password",
              label: "Password",
              children: [
                { value: "", label: "No Required" },
                { value: "required", label: "Required" },
              ],
            },
            {
              value: "radio",
              label: "Radio",
              children: [
                { value: "", label: "No Required" },
                { value: "required", label: "Required" },
              ],
            },
            {
              value: "checkbox",
              label: "Checkbox",
              children: [
                { value: "", label: "No Required" },
                { value: "required", label: "Required" },
              ],
            },
            {
              value: "date",
              label: "Date",
              children: [
                { value: "", label: "No Required" },
                { value: "required", label: "Required" },
              ],
            },
            {
              value: "datetime-local",
              label: "Datetime",
              children: [
                { value: "", label: "No Required" },
                { value: "required", label: "Required" },
              ],
            },
            {
              value: "email",
              label: "Email",
              children: [
                { value: "", label: "No Required" },
                { value: "required", label: "Required" },
              ],
            },
            {
              value: "month",
              label: "Month",
              children: [
                { value: "", label: "No Required" },
                { value: "required", label: "Required" },
              ],
            },
            {
              value: "number",
              label: "Number",
              children: [
                { value: "", label: "No Required" },
                { value: "required", label: "Required" },
              ],
            },
            {
              value: "range",
              label: "Range",
              children: [
                { value: "", label: "No Required" },
                { value: "required", label: "Required" },
              ],
            },
            {
              value: "tel",
              label: "Phone number",
              children: [
                { value: "", label: "No Required" },
                { value: "required", label: "Required" },
              ],
            },
            {
              value: "time",
              label: "Time",
              children: [
                { value: "", label: "No Required" },
                { value: "required", label: "Required" },
              ],
            },
            {
              value: "url",
              label: "Url",
              children: [
                { value: "", label: "No Required" },
                { value: "required", label: "Required" },
              ],
            },
            {
              value: "week",
              label: "Week",
              children: [
                { value: "", label: "No Required" },
                { value: "required", label: "Required" },
              ],
            },
          ],
        },
        {
          value: "select",
          label: "Select",
          children: [
            {
              value: "nomultiple",
              label: "No Multiple",
              children: [
                { value: "", label: "No Required" },
                { value: "required", label: "Required" },
              ],
            },
            {
              value: "multiple",
              label: "Multiple",
              children: [
                { value: "", label: "No Required" },
                { value: "required", label: "Required" },
              ],
            },
            {
              value: "callapi",
              label: "Call API",
              children: [
                { value: "", label: "No Required" },
                { value: "required", label: "Required" },
              ],
            },
          ],
        },
        {
          value: "textarea",
          label: "Textarea",
          children: [
            { value: "", label: "No Required" },
            { value: "required", label: "Required" },
          ],
        },
        {
          value: "table",
          label: "Table",
          children: [
            {
              value: "column",
              label: "Column",
              /* children: [
               { value: "", label:  <Checkbox onChange={onChange}>Checkbox1</Checkbox> },
             { value: "required", label:  <Checkbox onChange={onChange}>Checkbox2</Checkbox> },
             ],  */
            },
          ],
        },
      ],
      rulesOpt: [],
      disOpt: [],
      disBtn: true,
      disInput: true,
      dataColumnName: [],
      dataMasFormJson: {},
      datatableColumn: [],
      mode: "add",
      dataAdd: {
        condition: [{ key: 0, fieldKey: 0, name: 0 }],
        forms: [{ key: 0, fieldKey: 0, name: 0 }],
        language: ["English"],
      },
      btnType: "",
      TableColumnName: [],
      DataDynamic: [],
      format_form: {},
      select_index: 0,
      arr_modal: [],
      arr_backup: [],
      arr_modal_backup: [],

      /* add state form modal */
      apiFormData: {
        apiname: "",
        apiurl: "",
        receiveparameterkey: "",
        receiveparametervalue: "",
        sendparameter: [],
      },
      selectorFormData: {
        selectorname: "",
        /* selectorlabel: '', */
        selectoroption: [],
      },
      checkboxFormData: {
        checkboxname: "",
        /* checkboxlabel: '', */
        checkboxoption: [],
      },
      radioFormData: {
        radioname: "",
        /*   radiolabel: '', */
        radiooption: [],
      },
      textinputFormData: {
        textname: "",
        textmaxlength: "",
      },
      passwordinputFormData: {
        passwordname: "",
        passwordmaxlength: "",
      },
      emailinputFormData: {
        email: "",
        emailmaxlength: "",
      },
      textareainputFormData: {
        textarea: "",
        textareacolumns: "",
        textarearows: "",
        textareamaxlength: "",
      },
      dateinputFormData: {
        date: "",
      },
      datetimeinputFormData: {
        datetime: "",
      },
      monthinputFormData: {
        monthname: "",
      },
      numberinputFormData: {
        numbername: "",
      },
      rangeinputFormData: {
        rangename: "",
      },
      telinputFormData: {
        telname: "",
      },
      timeinputFormData: {
        timename: "",
      },
      urlinputFormData: {
        urlname: "",
        urlmaxlength:"",
      },
      weekinputFormData: {
        weekname: "",
      },
    };
  }

  componentDidMount() {
    //this.getDataGetMasFormJson("all");
    this.getDataGetMasFormJson("company_id=" + Cookies.get("companyid"));
  }

  async getDataGetMasFormJson(keyword) {
    keyword = keyword == "" ? "all" : keyword;
    const result = await Api.get("get_list_mas_form_json", keyword);
    // console.log(result);

    if (result.data.result.code === "P") {
      const data = result["data"]["data"]["mas_form_json_dto_list"];
      // console.log('getDataGetMasFormJson data : ')
      // console.log(data)
      this.setState({ data });
    }
  }

  async getDataMaxPageConfig(keyword) {
    keyword = keyword == "" ? "all" : keyword;
    const result = await Api.get("get_list_mas_form_json", keyword);
    console.log(result);

    if (result.data.result.code === "P") {
      const data = result["data"]["data"]["mas_form_json_dto_list"];
      console.log("getDataMaxPageConfig data : ");
      console.log(data);
      /*const len = data.length
      //console.log('len data : '+len)
      const index_max = len-1
      const max_id = data[index_max]["form_id"]
      const company_id = data[index_max]["company_id"]
      console.log('max_id : '+max_id+' , company_id : '+company_id)*/

      /** get config dynamic */
      /*const _data = {};
      _data.company_id = company_id;
      _data.page_name = 'full_detail_job'
      const res_config_dynamic = await Api.post("get_page_config_dynamic", _data);
      console.log('res_config_dynamic')
      console.log(res_config_dynamic)*/

      /** page config dynamic */
      /*const get_conf_dynamic = res_config_dynamic["data"]["data"]["pageConfigDynamic_dto_list"][0]
      console.log('get_conf_dynamic')     
      console.log(get_conf_dynamic)

      const _data_conf_dynamic = {};
      const page_id = get_conf_dynamic.page_id
      _data_conf_dynamic.company_id = company_id
      _data_conf_dynamic.page_id = page_id
      _data_conf_dynamic.obj_id = get_conf_dynamic.obj_id
      _data_conf_dynamic.obj_value = get_conf_dynamic.obj_value
      _data_conf_dynamic.dynamic_table_name = get_conf_dynamic.dynamic_table_name
      _data_conf_dynamic.is_active = get_conf_dynamic.is_active
      //_data_conf_dynamic.effective_date = get_conf_dynamic.effective_date
      _data_conf_dynamic.effective_date = get_conf_dynamic.effective_date !== undefined && get_conf_dynamic.effective_date !== "" && get_conf_dynamic.effective_date
          ? moment(get_conf_dynamic.effective_date, "DD/MM/YYYY").format("YYYY-MM-DD")
          : moment().format("YYYY-MM-DD");
      //_data_conf_dynamic.expire_date = get_conf_dynamic.expire_date
      _data_conf_dynamic.expire_date = get_conf_dynamic.expire_date !== undefined && get_conf_dynamic.expire_date !== "" && get_conf_dynamic.expire_date
      ? moment(get_conf_dynamic.expire_date, "DD/MM/YYYY").format("YYYY-MM-DD")
      : moment().format("YYYY-MM-DD");

      _data_conf_dynamic.create_date = get_conf_dynamic.create_date !== undefined && get_conf_dynamic.create_date !== "" && get_conf_dynamic.create_date
          ? moment(get_conf_dynamic.create_date).format("YYYY-MM-DD HH:mm:ss")
          : moment().format("YYYY-MM-DD HH:mm:ss");

      _data_conf_dynamic.create_by = get_conf_dynamic.create_by;
      _data_conf_dynamic.update_date = get_conf_dynamic.update_date !== undefined && get_conf_dynamic.update_date !== "" && get_conf_dynamic.update_date
          ? moment(get_conf_dynamic.update_date).format("YYYY-MM-DD HH:mm:ss")
          : moment().format("YYYY-MM-DD HH:mm:ss");      

      _data_conf_dynamic.update_by = get_conf_dynamic.update_by
      _data_conf_dynamic.form_id = max_id
      _data_conf_dynamic.data_dynamic = '{}'
      console.log('_data_conf_dynamic')
      console.log(_data_conf_dynamic)

      const update_config_dynamic = await Api.post("update_page_config_dynamic", _data_conf_dynamic);
      console.log('update_config_dynamic')
      console.log(update_config_dynamic)*/

      /** get config master */
      /*const _get_data = {};
      _get_data.company_id = company_id
      _get_data.page_id = page_id
      const res_config_master = await Api.post("get_page_config_master", _get_data);
      console.log('res_config_master')
      console.log(res_config_master)*/

      /** page config master */
      /*const get_conf_master = res_config_master["data"]["data"]["pageConfigMaster_dto_list"][0]
      const _data_conf_master = {};
      _data_conf_master.company_id = company_id
      _data_conf_master.page_id = get_conf_master.page_id
      _data_conf_master.page_name = get_conf_master.page_name
      _data_conf_master.page_path_name = get_conf_master.page_path_name
      _data_conf_master.page_url_name = get_conf_master.page_url_name
      _data_conf_master.is_active = get_conf_master.is_active
      _data_conf_master.effective_date = get_conf_master.effective_date !== undefined && get_conf_master.effective_date !== "" && get_conf_master.effective_date
      ? moment(get_conf_master.effective_date, "DD/MM/YYYY").format("YYYY-MM-DD")
      : moment().format("YYYY-MM-DD");

      _data_conf_master.expire_date = get_conf_master.expire_date !== undefined && get_conf_master.expire_date !== "" && get_conf_master.expire_date
      ? moment(get_conf_master.expire_date, "DD/MM/YYYY").format("YYYY-MM-DD")
      : moment().format("YYYY-MM-DD");

      _data_conf_master.create_date = get_conf_master.create_date !== undefined && get_conf_master.create_date !== "" && get_conf_master.create_date
      ? moment(get_conf_master.create_date).format("YYYY-MM-DD HH:mm:ss")
      : moment().format("YYYY-MM-DD HH:mm:ss");

      _data_conf_master.create_by = get_conf_master.create_by;
      _data_conf_master.update_date = get_conf_master.update_date !== undefined && get_conf_master.update_date !== "" && get_conf_master.update_date
      ? moment(get_conf_master.update_date).format("YYYY-MM-DD HH:mm:ss")
      : moment().format("YYYY-MM-DD HH:mm:ss");

      _data_conf_master.update_by = get_conf_master.update_by;
      _data_conf_master.form_id = max_id
      _data_conf_master.data_dynamic = '{}'

      console.log('_data_conf_master')
      console.log(_data_conf_master)

      const update_config_master = await Api.post("update_page_config_master", _data_conf_master);
      console.log('update_config_master')
      console.log(update_config_master)*/

      this.setState({ data });
    }
  }

  async handleSubmit(values) {
    //console.log("Success:", values);
    const { mode, dataMasFormJson, valueMasterLanguage } = this.state;
    const data = {};
    if (mode === "edit") {
      let condition = {};
      let column = [];
      let form_json = "";
      let language = "";
      if (values.condition !== undefined) {
        for (let x in values.condition) {
          condition[values.condition[x].column_name] =
            values.condition[x].value;
          column.push(values.condition[x].column_name);
        }
      }
      for (let j in valueMasterLanguage) {
        language = language
          ? language + "," + valueMasterLanguage[j].key
          : valueMasterLanguage[j].key;
      }
      if (values.forms !== undefined) {
        form_json = JSON.stringify(
          this.formatData(values.table_name, values.forms)
        );
      }
      data.form_id = dataMasFormJson.form_id;
      data.schema = dataMasFormJson.schema;
      data.company_id = values.company;
      data.table_name = values.table_name;
      data.column_roles = column;
      data.data_roles = condition;
      data.language = language;
      data.form_json = form_json;
      data.effective_date = moment(values.effective_date, "DD/MM/YYYY").format(
        "YYYY-MM-DD"
      );
      data.expire_date =
        values.expire_date !== undefined && values.expire_date !== ""
          ? moment(values.expire_date, "DD/MM/YYYY").format("YYYY-MM-DD")
          : "";
      data.update_date = moment().format("YYYY-MM-DD HH:mm:ss");
      data.update_by = 0;
    } else {
      /** add new record */
      let condition = {};
      let column = [];
      let form_json = "";
      let language = "";
      let output_json = "";
      let value_json = "";
      if (values.condition !== undefined) {
        for (let x in values.condition) {
          condition[values.condition[x].column_name] =
            values.condition[x].value;
          column.push(values.condition[x].column_name);
        }
      }
      for (let j in valueMasterLanguage) {
        language = language
          ? language + "," + valueMasterLanguage[j].key
          : valueMasterLanguage[j].key;
      }
      if (values.forms !== undefined) {
        form_json = JSON.stringify(
          this.formatData(values.table_name, values.forms)
        );

        output_json = JSON.stringify(
          this.formatOutput(values.table_name, values.forms)
        );

        value_json = this.formatValue(values.table_name, values.forms);
        // value_json = JSON.stringify(
        //   this.formatValue(values.table_name, values.forms)
        // );
      }
      //output_json
      console.log("handlesubmit values : ");
      console.log(values);

      //data.company_id = 1;
      data.company_id = values.company;
      data.schema = values.schema;
      data.table_name = values.table_name;
      data.column_roles = column;
      data.data_roles = condition;
      data.language = language;
      data.form_json = form_json;

      data.output_json = output_json;
      data.value_json = value_json;
      data.effective_date = moment(values.effective_date, "DD/MM/YYYY").format(
        "YYYY-MM-DD"
      );
      data.expire_date =
        values.expire_date !== undefined && values.expire_date !== ""
          ? moment(values.expire_date, "DD/MM/YYYY").format("YYYY-MM-DD")
          : "";
      data.create_date = moment().format("YYYY-MM-DD HH:mm:ss");
      data.create_by = 0;
      data.update_date = moment().format("YYYY-MM-DD HH:mm:ss");
      data.update_by = 0;
    }

    console.log("data add :");
    console.log(data);

    /** connect API */
    const result = await Api.post("update_mas_form_json", data);
    if (result.data.result.code === "P") {
      this.setState(
        {
          visible: false,
        },
        () => {
          //this.getDataMaxPageConfig("all");
          this.getDataMaxPageConfig("company_id=" + Cookies.get("companyid"));
        }
      );
    } else {
      return Modal.error({
        title: "This is an error message",
        content: result.data.result.description,
      });
    }
  }

  onChange = (e) => {
    this.setState({ value: e.target.value });
  };

  async getDataGetMasterLanguage() {
    const result = await Api.get("get_master_language", "");
    if (result.data.result.code === "P") {
      const dataMasterLanguage =
        result["data"]["data"]["master_language_dto_list"];
      this.setState({ dataMasterLanguage });
    }
  }

  async onModal(key, mode, visible, obj) {
    console.log(obj);
    this.getDataGetMasterLanguage();
    if (mode === "add") {
      this.setState({
        visible,
        dataTableName: [],
        valueTableName: "",
        disBtn: true,
        disInput: true,
        dataColumnName: [],
        mode,
        btnType: obj,
        valueMasterLanguage: [
          {
            children: ["English", " (", "EN", ")"],
            key: "EN",
            value: "English",
          },
        ],
      });
    } else {
      const valueMasterLanguage = [];
      const result = await Api.get("get_mas_form_json", key);
      if (result.data.result.code === "P") {
        const data = result["data"]["data"]["mas_form_json_dto_list"];
        if (data.length > 0) {
          const dataMasFormJson = data[0];
          if (
            dataMasFormJson["expire_date"] !== "" &&
            dataMasFormJson["expire_date"] !== null
          ) {
            dataMasFormJson["expire_date"] = moment(
              dataMasFormJson["expire_date"],
              "YYYY/MM/DD"
            );
          }
          dataMasFormJson["language_name"] = dataMasFormJson[
            "language_name"
          ].split(",");
          const language = dataMasFormJson["language"].split(",");
          if (language.length > 0) {
            for (let x in language) {
              valueMasterLanguage.push({
                children: [
                  dataMasFormJson["language_name"][x],
                  " (",
                  language[x],
                  ")",
                ],
                key: language[x],
                value: dataMasFormJson["language_name"][x],
              });
            }
          }
          dataMasFormJson["condition"] = this.setConditions(
            dataMasFormJson["data_roles"]
          );
          dataMasFormJson["forms"] = this.setForms(dataMasFormJson, language);
          this.setState(
            {
              dataMasFormJson,
              mode,
              valueMasterLanguage,
            },
            () => {
              this.setState({ visible });
            }
          );
        } else {
          this.setState({ visible });
        }
      }
    }
  }

  handleOk = (e) => {
    //console.log(e);
    const {
      // count_component,
      count_modal,
      select_index,
      arr_modal,
    } = this.state;
    console.log("click ok");
    console.log("arr_modal");
    console.log(arr_modal);
    console.log("count_modal : " + count_modal);
    console.log("select_index : " + select_index);

    var cloneComponent = JSON.parse(JSON.stringify(this.state)).count_component; // clone
    cloneComponent.map((field, index) => {
      // console.log("index : " + index);
      // console.log(field);
      if (field.id === select_index) {
        console.log("if field");
        console.log(field);
        console.log("if arr_modal");
        console.log(arr_modal);
        field.value = count_modal;
        field.component = arr_modal;
      }
    });

    console.log("cloneComponent : ");
    console.log(cloneComponent);

    this.setState({
      visibleConfig: false,
      count_component: cloneComponent,
    });
  };

  handleCancel = (e) => {
    const { arr_backup, arr_modal_backup } = this.state;

    // console.log(e);
    //console.log('click cancel')

    this.setState({
      count_component: arr_backup,
      arr_modal: arr_modal_backup,
      visibleConfig: false,
    });
  };

  loopComponent(data, arr_component) {
    const { arr_modal } = this.state;
    // let option = data.split(",");
    // console.log("arr_component");
    // console.log(arr_component);
    // console.log("arr_modal loopComponent");
    // console.log(arr_modal);

    let options = [];
    for (let i = 0; i < data; i++) {
      options.push(this.component_table(i, arr_component, data));
    }
    return options;
  }

  renderModalConfig() {
    // const { valueMasterLanguage, disBtn , rulesOpt , disOpt } = this.state;
    const { count_modal, count_component, arr_modal } = this.state;
    // console.log("arr_modal renderModalConfig");
    // console.log(arr_modal);

    return (
      <Modal
        visible={this.state.visibleConfig}
        onOk={this.handleOk}
        onCancel={this.handleCancel}
        title={
          <span className="font-mont-b fs-16 c-blue text-uppercase">
            Config Table
          </span>
        }
        centered
        className="custom-modal"
        destroyOnClose={true}
      >
        <Button
          type="primary"
          onClick={() => {
            this.addColumn();
          }}
          style={{ width: "15%" }}
        >
          Add Column
        </Button>

        <Form>{this.loopComponent(count_modal, arr_modal)}</Form>
      </Modal>
    );
  }

  /*  add modal api and selector */
  toggleModalShow(modalType) {
    switch (modalType) {
      case "callapi":
        this.setState({
          showApiConfigModal: true,
        });

        break;
      case "nomultiple":
        this.setState({
          showSelectConfigModal: true,
        });
        break;
      case "multiple":
        this.setState({
          showSelectConfigModal: true,
        });
        break;
      case "checkbox":
        this.setState({
          showCheckboxConfigModal: true,
        });
        break;
      case "radio":
        this.setState({
          showRadioConfigModal: true,
        });
        break;
      case "text":
        this.setState({
          showTextinputConfigModal: true,
        });
        break;
      case "password":
        this.setState({
          showPasswordinputConfigModal: true,
        });
        break;
      case "date":
        this.setState({
          showDateinputConfigModal: true,
        });
        break;
      case "datetime-local":
        this.setState({
          showDateTimeinputConfigModal: true,
        });
        break;
      case "email":
        this.setState({
          showEmailinputConfigModal: true,
        });
        break;
      case "month":
        this.setState({ showMonthinputConfigModal: true });
        break;
      case "number":
        this.setState({ showNumberinputConfigModal: true });
        break;
      case "range":
        this.setState({ showRangeinputConfigModal: true });
        break;
      case "tel":
        this.setState({ showPhoneNumberinputConfigModal: true });
        break;
      case "time":
        this.setState({ showTimeinputConfigModal: true });
        break;
      case "url":
        this.setState({ showUrlinputConfigModal: true });
        break;
      case "week":
        this.setState({ showWeekinputConfigModal: true });
        break;
      case "textarea":
        this.setState({ showTextAreainputConfigModal: true });
        break;
      default:
        return null;
    }
  }
  /* handle section */
  handleModalOk = (type, e) => {
    e.preventDefault();
    switch (type) {
      default:
        return null;
      case "api":
        this.setState({
          showApiConfigModal: false,
        });
        break;
      case "select":
        this.setState({
          showSelectConfigModal: false,
        });
        break;
      case "checkbox":
        this.setState({
          showCheckboxConfigModal: false,
        });
        break;
      case "radio":
        this.setState({
          showRadioConfigModal: false,
        });
        break;
      case "textinput":
        this.setState({
          showTextinputConfigModal: false,
        });
        break;
      case "passwordinput":
        this.setState({
          showPasswordinputConfigModal: false,
        });
        break;
      case "dateinput":
        this.setState({
          showDateinputConfigModal: false,
        });
        break;
      case "datetimeinput":
        this.setState({
          showDateTimeinputConfigModal: false,
        });
        break;
      case "emailinput":
        this.setState({
          showEmailinputConfigModal: false,
        });
        break;
      case "monthinput":
        this.setState({
          showMonthinputConfigModal: false,
        });
        break;
      case "numberinput":
        this.setState({ showNumberinputConfigModal: false });
        break;
      case "rangeinput":
        this.setState({ showRangeinputConfigModal: false });
        break;
      case "telinput":
        this.setState({ showPhoneNumberinputConfigModal: false });
        break;
      case "timeinput":
        this.setState({ showTimeinputConfigModal: false });
        break;
      case "urlinput":
        this.setState({ showUrlinputConfigModal: false });
        break;
      case "weekinput":
        this.setState({ showWeekinputConfigModal: false });
        break;
      case "textareainput":
        this.setState({ showTextAreainputConfigModal: false });
        break;
    }
  };

  handleModalCancel = (type, e) => {
    switch (type) {
      default:
        return null;
      case "api":
        this.setState({
          showApiConfigModal: false,
        });
        break;
      case "select":
        this.setState({
          showSelectConfigModal: false,
        });
        break;
      case "checkbox":
        this.setState({
          showCheckboxConfigModal: false,
        });
        break;
      case "radio":
        this.setState({
          showRadioConfigModal: false,
        });
        break;
      case "textinput":
        this.setState({
          showTextinputConfigModal: false,
        });
        break;
      case "passwordinput":
        this.setState({
          showPasswordinputConfigModal: false,
        });
        break;
      case "dateinput":
        this.setState({
          showDateinputConfigModal: false,
        });
        break;
      case "datetimeinput":
        this.setState({
          showDateTimeinputConfigModal: false,
        });
        break;
      case "emailinput":
        this.setState({
          showEmailinputConfigModal: false,
        });
        break;
      case "monthinput":
        this.setState({ showMonthinputConfigModal: false });
        break;
      case "numberinput":
        this.setState({ showNumberinputConfigModal: false });
        break;
      case "rangeinput":
        this.setState({ showRangeinputConfigModal: false });
        break;
      case "telinput":
        this.setState({ showPhoneNumberinputConfigModal: false });
        break;
      case "timeinput":
        this.setState({ showTimeinputConfigModal: false });
        break;
      case "urlinput":
        this.setState({ showUrlinputConfigModal: false });
        break;
      case "weekinput":
        this.setState({ showWeekinputConfigModal: false });
        break;
      case "textareainput":
        this.setState({ showTextAreainputConfigModal: false });
        break;
    }
  };

  handleModalValuesChange = (type, key, e) => {
    switch (type) {
      case "api":
        const apiFormData = this.state.apiFormData;
        if (key !== null) {
          apiFormData.sendparameter[key] = {
            ...apiFormData.sendparameter[key],
            [e.target.name]: e.target.value,
          };
        } else {
          apiFormData[e.target.name] = e.target.value;
        }
        this.setState({ apiFormData: apiFormData });
        //console.log(this.state.apiFormData);
        break;

      case "select":
        const selectorFormData = this.state.selectorFormData;
        if (key !== null) {
          selectorFormData.selectoroption[key] = {
            ...selectorFormData.selectoroption[key],
            [e.target.name]: e.target.value,
          };
        } else {
          selectorFormData[e.target.name] = e.target.value;
        }
        this.setState({ selectorFormData: selectorFormData });
        break;

      case "checkbox":
        const checkboxFormdata = this.state.checkboxFormData;
        if (key !== null) {
          checkboxFormdata.checkboxoption[key] = {
            ...checkboxFormdata.checkboxoption[key],
            [e.target.name]: e.target.value,
          };
        } else {
          checkboxFormdata[e.target.name] = e.target.value;
        }
        this.setState({ checkboxFormData: checkboxFormdata });
        break;

      case "radio":
        const radioFormData = this.state.radioFormData;
        if (key !== null) {
          radioFormData.radiooption[key] = {
            ...radioFormData.radiooption[key],
            [e.target.name]: e.target.value,
          };
        } else {
          radioFormData[e.target.name] = e.target.value;
        }
        this.setState({ radioFormData: radioFormData });
        break;
      case "textinput":
        const textinputFormData = this.state.textinputFormData;
        if (key !== null) {
          textinputFormData.textinputoption[key] = {
            ...textinputFormData.textinputoption[key],
            [e.target.name]: e.target.value,
          };
        } else {
          textinputFormData[e.target.name] = e.target.value;
        }
        this.setState({ textinputFormData: textinputFormData });
        break;

      
      case "passwordinput":
        const passwordinputFormData = this.state.passwordinputFormData;
        if (key !== null) {
          passwordinputFormData.textinputoption[key] = {
            ...passwordinputFormData.textinputoption[key],
            [e.target.name]: e.target.value,
          };
        } else {
          passwordinputFormData[e.target.name] = e.target.value;
        }
        this.setState({ passwordinputFormData: passwordinputFormData });
        break;
      
      case "dateinput":
        const dateinputFormData = this.state.dateinputFormData;
        if (key !== null) {
          dateinputFormData.textinputoption[key] = {
            ...dateinputFormData.textinputoption[key],
            [e.target.name]: e.target.value,
          };
        } else {
          dateinputFormData[e.target.name] = e.target.value;
        }
        this.setState({ dateinputFormData: dateinputFormData });
        break;
      
      case "datetimeinput":
        const datetimeinputFormData = this.state.datetimeinputFormData;
        if (key !== null) {
          datetimeinputFormData.textinputoption[key] = {
            ...datetimeinputFormData.textinputoption[key],
            [e.target.name]: e.target.value,
          };
        } else {
          datetimeinputFormData[e.target.name] = e.target.value;
        }
        this.setState({ datetimeinputFormData: datetimeinputFormData });
        break;
      
      case "emailinput":
        const emailinputFormData = this.state.emailinputFormData;
        if (key !== null) {
          emailinputFormData.textinputoption[key] = {
            ...emailinputFormData.textinputoption[key],
            [e.target.name]: e.target.value,
          };
        } else {
          emailinputFormData[e.target.name] = e.target.value;
        }
        this.setState({ emailinputFormData: emailinputFormData });
        break;
      
      case "monthinput":
        const monthinputFormData = this.state.monthinputFormData;
        if (key !== null) {
          monthinputFormData.textinputoption[key] = {
            ...monthinputFormData.textinputoption[key],
            [e.target.name]: e.target.value,
          };
        } else {
          monthinputFormData[e.target.name] = e.target.value;
        }
        this.setState({ monthinputFormData: monthinputFormData });
        break;
      
      case "numberinput":
        const numberinputFormData = this.state.numberinputFormData;
        if (key !== null) {
          numberinputFormData.textinputoption[key] = {
            ...numberinputFormData.textinputoption[key],
            [e.target.name]: e.target.value,
          };
        } else {
          numberinputFormData[e.target.name] = e.target.value;
        }
        this.setState({ numberinputFormData: numberinputFormData });
        break;

      case "rangeinput":
        const rangeinputFormData = this.state.rangeinputFormData;
        if (key !== null) {
          rangeinputFormData.textinputoption[key] = {
            ...rangeinputFormData.textinputoption[key],
            [e.target.name]: e.target.value,
          };
        } else {
          rangeinputFormData[e.target.name] = e.target.value;
        }
        this.setState({ rangeinputFormData: rangeinputFormData });
        break;

      case "telinput":
        const telinputFormData = this.state.telinputFormData;
        if (key !== null) {
          telinputFormData.textinputoption[key] = {
            ...telinputFormData.textinputoption[key],
            [e.target.name]: e.target.value,
          };
        } else {
          telinputFormData[e.target.name] = e.target.value;
        }
        this.setState({ telinputFormData: telinputFormData });
        break;
      
      case "timeinput":
        const timeinputFormData = this.state.timeinputFormData;
        if (key !== null) {
          timeinputFormData.textinputoption[key] = {
            ...timeinputFormData.textinputoption[key],
            [e.target.name]: e.target.value,
          };
        } else {
          timeinputFormData[e.target.name] = e.target.value;
        }
        this.setState({ timeinputFormData: timeinputFormData });
        break;
      
      case "urlinput":
        const urlinputFormData = this.state.urlinputFormData;
        if (key !== null) {
          urlinputFormData.textinputoption[key] = {
            ...urlinputFormData.textinputoption[key],
            [e.target.name]: e.target.value,
          };
        } else {
          urlinputFormData[e.target.name] = e.target.value;
        }
        this.setState({ urlinputFormData: urlinputFormData });
        break;
      
      case "weekinput":
        const weekinputFormData = this.state.weekinputFormData;
        if (key !== null) {
          weekinputFormData.textinputoption[key] = {
            ...weekinputFormData.textinputoption[key],
            [e.target.name]: e.target.value,
          };
        } else {
          weekinputFormData[e.target.name] = e.target.value;
        }
        this.setState({ weekinputFormData: weekinputFormData });
        break;
      
      case "textareainput":
        const textareainputFormData = this.state.textareainputFormData;
        if (key !== null) {
          textareainputFormData.textinputoption[key] = {
            ...textareainputFormData.textinputoption[key],
            [e.target.name]: e.target.value,
          };
        } else {
          textareainputFormData[e.target.name] = e.target.value;
        }
        this.setState({ textareainputFormData: textareainputFormData });
        break;

      default:
        return null;
    }
  };

  /* renderModal Section */
  renderModelAPI() {
    return (
      <Modal
        visible={this.state.showApiConfigModal}
        onOk={this.handleModalOk.bind(this, "api")}
        onCancel={this.handleModalCancel.bind(this, "api")}
        title={
          <span className="font-mont-b fs-16 c-blue text-uppercase">
            Config API
          </span>
        }
        centered
        className="custom-modal"
        destroyOnClose={true}
      >
        <Form>
          <Divider orientation="left">API Name and URL</Divider>
          <Form.Item
            label="API Name"
            style={{ marginLeft: "50px" }}
            rules={[{ required: true, message: "Name is required" }]}
          >
            <Input
              style={{ width: 550 }}
              placeholder="Please input API name"
              name="apiname"
              value={this.state.apiFormData.apiname}
              onChange={this.handleModalValuesChange.bind(this, "api", null)}
            />
          </Form.Item>
          <Form.Item
            label="URL : "
            style={{ marginLeft: "50px" }}
            rules={[{ required: true, message: "URL is required" }]}
          >
            <Input
              style={{ width: 550 }}
              placeholder="Please input URL"
              name="apiurl"
              value={this.state.apiFormData.apiurl}
              onChange={this.handleModalValuesChange.bind(this, "api", null)}
            />
          </Form.Item>
          <Divider orientation="left">Receive Parameter</Divider>
          <Form.Item
            label="Receive Parameter"
            style={{ marginLeft: "50px" }}
            rules={[{ required: true, message: "" }]}
          >
            <Input
              style={{ width: 260 }}
              placeholder="Input Parameter Key"
              name="receiveparameterkey"
              value={this.state.apiFormData.receiveparameterkey}
              onChange={this.handleModalValuesChange.bind(this, "api", null)}
            />
            <Input
              style={{ width: 260, marginLeft: "5px" }}
              placeholder="Input Parameter Value"
              name="receiveparametervalue"
              value={this.state.apiFormData.receiveparametervalue}
              onChange={this.handleModalValuesChange.bind(this, "api", null)}
            />
          </Form.Item>
          <Divider orientation="left">Send Parameter</Divider>
          <Form.List name="sendparameter">
            {(fields, { add, remove }) => (
              <>
                {fields.map((field) => (
                  <Space
                    key={field.key}
                    style={{ display: "flex", marginBottom: 8 }}
                    align="baseline"
                  >
                    <Form.Item
                      {...field}
                      name={[field.name, "first"]}
                      label="Parameter Key"
                      fieldKey={[field.fieldKey, "first"]}
                      style={{ marginLeft: "50px" }}
                      rules={[
                        { required: true, message: "Missing Parameter Key" },
                      ]}
                    >
                      <Input
                        placeholder="Input Parameter Key"
                        name="key"
                        onChange={this.handleModalValuesChange.bind(
                          this,
                          "api",
                          field.fieldKey
                        )}
                      />
                    </Form.Item>
                    <Form.Item
                      {...field}
                      name={[field.name, "last"]}
                      fieldKey={[field.fieldKey, "last"]}
                      label="Parameter Value"
                      rules={[{ required: true, message: "Parameter Value" }]}
                    >
                      <Input
                        placeholder="Input Parameter Value"
                        name="value"
                        onChange={this.handleModalValuesChange.bind(
                          this,
                          "api",
                          field.fieldKey
                        )}
                      />
                    </Form.Item>
                    <MinusCircleOutlined onClick={() => remove(field.name)} />
                  </Space>
                ))}
                <Form.Item>
                  <Button
                    type="dashed"
                    onClick={() => add()}
                    block
                    icon={<PlusOutlined />}
                  >
                    Add Send Parameter
                  </Button>
                </Form.Item>
              </>
            )}
          </Form.List>
        </Form>
      </Modal>
    );
  }

  renderModelSelect() {
    return (
      <Modal
        visible={this.state.showSelectConfigModal}
        onOk={this.handleModalOk.bind(this, "select")}
        onCancel={this.handleModalCancel.bind(this, "select")}
        title={
          <span className="font-mont-b fs-16 c-blue text-uppercase">
            Config Selector
          </span>
        }
        centered
        className="custom-modal"
        destroyOnClose={true}
      >
        <Form>
          <Divider orientation="left">Selector Name</Divider>
          <Form.Item
            label="Slector Name"
            style={{ marginLeft: "50px" }}
            rules={[{ required: true, message: "Selector name is required" }]}
          >
            <Input
              style={{ width: 360 }}
              placeholder="Please input selector name"
              name="selectorname"
              value={this.state.selectorFormData.selectorname}
              onChange={this.handleModalValuesChange.bind(this, "select", null)}
            />
          </Form.Item>
          <Divider orientation="left">Selector Options</Divider>
          <Form.List name="selectoroption">
            {(fieldselector, { add, remove }) => (
              <>
                {fieldselector.map((field) => (
                  <Space
                    key={field.key}
                    style={{ display: "flex", marginBottom: 8 }}
                    align="baseline"
                  >
                    <Form.Item
                      {...field}
                      name={[field.name, "selectoroptionvalues"]}
                      label="Option Value"
                      fieldKey={[field.fieldKey, "selectoroptionvalues"]}
                      style={{ marginLeft: "50px" }}
                      rules={[
                        { required: true, message: "Missing option value" },
                      ]}
                    >
                      <Input
                        placeholder="Input option value"
                        name="value"
                        onChange={this.handleModalValuesChange.bind(
                          this,
                          "select",
                          field.fieldKey
                        )}
                      />
                    </Form.Item>
                    <Form.Item
                      {...field}
                      name={[field.name, "selectoroptionlabel"]}
                      fieldKey={[field.fieldKey, "selectoroptionlabel"]}
                      label="Option label (Show)"
                      rules={[
                        { required: true, message: "Missing option label" },
                      ]}
                    >
                      <Input
                        placeholder="Input option label"
                        name="label"
                        onChange={this.handleModalValuesChange.bind(
                          this,
                          "select",
                          field.fieldKey
                        )}
                      />
                    </Form.Item>
                    <MinusCircleOutlined onClick={() => remove(field.name)} />
                  </Space>
                ))}
                <Form.Item>
                  <Button
                    type="dashed"
                    onClick={() => add()}
                    block
                    icon={<PlusOutlined />}
                  >
                    Add Selector Option
                  </Button>
                </Form.Item>
              </>
            )}
          </Form.List>
        </Form>
      </Modal>
    );
  }

  renderModelCheckbox() {
    return (
      <Modal
        visible={this.state.showCheckboxConfigModal}
        onOk={this.handleModalOk.bind(this, "checkbox")}
        onCancel={this.handleModalCancel.bind(this, "checkbox")}
        title={
          <span className="font-mont-b fs-16 c-blue text-uppercase">
            Config Checkbox
          </span>
        }
        centered
        className="custom-modal"
        destroyOnClose={true}
      >
        <Form>
          <Divider orientation="left">Checkbox Name</Divider>
          <Form.Item
            label="Checkbox Name"
            style={{ marginLeft: "50px" }}
            rules={[{ required: true, message: "Checkbox name is required" }]}
          >
            <Input
              style={{ width: 360 }}
              placeholder="Please input checkbox name"
              name="checkboxname"
              value={this.state.checkboxFormData.checkboxname}
              onChange={this.handleModalValuesChange.bind(
                this,
                "checkbox",
                null
              )}
            />
          </Form.Item>
          <Divider orientation="left">Checkbox Options</Divider>
          <Form.List name="checkboxoption">
            {(fieldcheckbox, { add, remove }) => (
              <>
                {fieldcheckbox.map((field) => (
                  <Space
                    key={field.key}
                    style={{ display: "flex", marginBottom: 8 }}
                    align="baseline"
                  >
                    <Form.Item
                      {...field}
                      name={[field.name, "checkboxoptionname"]}
                      label="Option name"
                      fieldKey={[field.fieldKey, "checkboxoptionname"]}
                      style={{ marginLeft: "50px" }}
                      rules={[
                        { required: true, message: "Missing option name" },
                      ]}
                    >
                      <Input
                        placeholder="Input checkboox option name"
                        name="name"
                        onChange={this.handleModalValuesChange.bind(
                          this,
                          "checkbox",
                          field.fieldKey
                        )}
                      />
                    </Form.Item>
                    <Form.Item
                      {...field}
                      name={[field.name, "checkboxoptionvalue"]}
                      fieldKey={[field.fieldKey, "checkboxoptionvalue"]}
                      label="Option value"
                      rules={[
                        { required: true, message: "Missing option value" },
                      ]}
                    >
                      <Input
                        placeholder="Input checkbox option value"
                        name="value"
                        onChange={this.handleModalValuesChange.bind(
                          this,
                          "checkbox",
                          field.fieldKey
                        )}
                      />
                    </Form.Item>
                    <Form.Item
                      {...field}
                      name={[field.name, "checkboxoptionlabel"]}
                      fieldKey={[field.fieldKey, "checkboxoptionlabel"]}
                      label="Option label"
                      rules={[
                        { required: true, message: "Missing option label" },
                      ]}
                    >
                      <Input
                        placeholder="Input checkbox option label"
                        name="label"
                        onChange={this.handleModalValuesChange.bind(
                          this,
                          "checkbox",
                          field.fieldKey
                        )}
                      />
                    </Form.Item>
                    <MinusCircleOutlined onClick={() => remove(field.name)} />
                  </Space>
                ))}
                <Form.Item>
                  <Button
                    type="dashed"
                    onClick={() => add()}
                    block
                    icon={<PlusOutlined />}
                  >
                    Add Checkbox Option
                  </Button>
                </Form.Item>
              </>
            )}
          </Form.List>
        </Form>
      </Modal>
    );
  }

  renderModelRadio() {
    return (
      <Modal
        visible={this.state.showRadioConfigModal}
        onOk={this.handleModalOk.bind(this, "radio")}
        onCancel={this.handleModalCancel.bind(this, "radio")}
        title={
          <span className="font-mont-b fs-16 c-blue text-uppercase">
            Config Radio
          </span>
        }
        centered
        className="custom-modal"
        destroyOnClose={true}
      >
        <Form>
          <Divider orientation="left">Radio Name</Divider>
          <Form.Item
            label="Radio Name"
            style={{ marginLeft: "50px" }}
            rules={[{ required: true, message: "Radio name is required" }]}
          >
            <Input
              style={{ width: 360 }}
              placeholder="Please input radio name"
              name="radioname"
              value={this.state.radioFormData.radioname}
              onChange={this.handleModalValuesChange.bind(this, "radio", null)}
            />
          </Form.Item>
          <Divider orientation="left">Radio Options</Divider>
          <Form.List name="radiooption">
            {(fieldradio, { add, remove }) => (
              <>
                {fieldradio.map((field) => (
                  <Space
                    key={field.key}
                    style={{ display: "flex", marginBottom: 8 }}
                    align="baseline"
                  >
                    <Form.Item
                      {...field}
                      name={[field.name, "radiooptionname"]}
                      label="Option name"
                      fieldKey={[field.fieldKey, "radiooptionname"]}
                      style={{ marginLeft: "50px" }}
                      rules={[
                        { required: true, message: "Missing option name" },
                      ]}
                    >
                      <Input
                        placeholder="Input radio option name"
                        name="name"
                        onChange={this.handleModalValuesChange.bind(
                          this,
                          "radio",
                          field.fieldKey
                        )}
                      />
                    </Form.Item>
                    <Form.Item
                      {...field}
                      name={[field.name, "radiooptionvalue"]}
                      fieldKey={[field.fieldKey, "radiooptionvalue"]}
                      label="Option value"
                      rules={[
                        { required: true, message: "Missing option value" },
                      ]}
                    >
                      <Input
                        placeholder="Input radio option value"
                        name="value"
                        onChange={this.handleModalValuesChange.bind(
                          this,
                          "radio",
                          field.fieldKey
                        )}
                      />
                    </Form.Item>
                    <Form.Item
                      {...field}
                      name={[field.name, "radiooptionlabel"]}
                      fieldKey={[field.fieldKey, "radiooptionlabel"]}
                      label="Option label"
                      rules={[
                        { required: true, message: "Missing option label" },
                      ]}
                    >
                      <Input
                        placeholder="Input radio option label"
                        name="label"
                        onChange={this.handleModalValuesChange.bind(
                          this,
                          "radio",
                          field.fieldKey
                        )}
                      />
                    </Form.Item>
                    <MinusCircleOutlined onClick={() => remove(field.name)} />
                  </Space>
                ))}
                <Form.Item>
                  <Button
                    type="dashed"
                    onClick={() => add()}
                    block
                    icon={<PlusOutlined />}
                  >
                    Add Radio Option
                  </Button>
                </Form.Item>
              </>
            )}
          </Form.List>
        </Form>
      </Modal>
    );
  }

  renderModelTextInput() {
    return (
      <Modal
        visible={this.state.showTextinputConfigModal}
        onOk={this.handleModalOk.bind(this, "textinput")}
        onCancel={this.handleModalCancel.bind(this, "textinput")}
        title={
          <span className="font-mont-b fs-16 c-blue text-uppercase">
            Config Text Input
          </span>
        }
        centered
        className="custom-modal"
        destroyOnClose={true}
      >
        <Form>
          <Divider orientation="left">Text Input Attribute</Divider>
          <Form.Item
            label="Text input name"
            style={{ marginLeft: "50px" }}
            rules={[
              { required: true, message: "Text input text name is required" },
            ]}
          >
            <Input
              style={{ width: 360 }}
              placeholder="Please input text name"
              name="textname"
              value={this.state.textinputFormData.sectionname}
              onChange={this.handleModalValuesChange.bind(
                this,
                "textinput",
                null
              )}
            />
          </Form.Item>
          <Form.Item
            label="Text input max length"
            style={{ marginLeft: "50px" }}
            rules={[
              {
                required: true,
                message: "Text input text max length is required",
              },
            ]}
          >
            <Input
              style={{ width: 360 }}
              placeholder="Please input text max length"
              name="textmaxlength"
              value={this.state.textinputFormData.sectionname}
              onChange={this.handleModalValuesChange.bind(
                this,
                "textinput",
                null
              )}
            />
          </Form.Item>
        </Form>
      </Modal>
    );
  }

  renderModelPasswordInput() {
    return (
      <Modal
        visible={this.state.showPasswordinputConfigModal}
        onOk={this.handleModalOk.bind(this, "passwordinput")}
        onCancel={this.handleModalCancel.bind(this, "passwordinput")}
        title={
          <span className="font-mont-b fs-16 c-blue text-uppercase">
            Config Password Input
          </span>
        }
        centered
        className="custom-modal"
        destroyOnClose={true}
      >
        <Form>
          <Divider orientation="left">Password Input Attribute</Divider>
          <Form.Item
            label="Password input name"
            style={{ marginLeft: "50px" }}
            rules={[
              {
                required: true,
                message: "Text input password name is required",
              },
            ]}
          >
            <Input
              style={{ width: 360 }}
              placeholder="Please input password name"
              name="passwordname"
              value={this.state.passwordinputFormData.sectionname}
              onChange={this.handleModalValuesChange.bind(
                this,
                "passwordinput",
                null
              )}
            />
          </Form.Item>
          <Form.Item
            label="Password input max length"
            style={{ marginLeft: "50px" }}
            rules={[
              {
                required: true,
                message: "Text input password max length is required",
              },
            ]}
          >
            <Input
              style={{ width: 360 }}
              placeholder="Please input password max length"
              name="passwordmaxlength"
              value={this.state.textinputFormData.sectionname}
              onChange={this.handleModalValuesChange.bind(
                this,
                "passwordinput",
                null
              )}
            />
          </Form.Item>
        </Form>
      </Modal>
    );
  }

  renderModelDateInput() {
    return (
      <Modal
        visible={this.state.showDateinputConfigModal}
        onOk={this.handleModalOk.bind(this, "dateinput")}
        onCancel={this.handleModalCancel.bind(this, "dateinput")}
        title={
          <span className="font-mont-b fs-16 c-blue text-uppercase">
            Config Date Input
          </span>
        }
        centered
        className="custom-modal"
        destroyOnClose={true}
      >
        <Form>
          <Divider orientation="left">Date Input Name</Divider>
          <Form.Item
            label="Date input name"
            style={{ marginLeft: "50px" }}
            rules={[
              { required: true, message: "Date input date name is required" },
            ]}
          >
            <Input
              style={{ width: 360 }}
              placeholder="Please input date name"
              name="date"
              value={this.state.dateinputFormData.sectionname}
              onChange={this.handleModalValuesChange.bind(
                this,
                "dateinput",
                null
              )}
            />
          </Form.Item>
        </Form>
      </Modal>
    );
  }

  renderModelDateTimeInput() {
    return (
      <Modal
        visible={this.state.showDateTimeinputConfigModal}
        onOk={this.handleModalOk.bind(this, "datetimeinput")}
        onCancel={this.handleModalCancel.bind(this, "datetimeinput")}
        title={
          <span className="font-mont-b fs-16 c-blue text-uppercase">
            Config DateTime Input
          </span>
        }
        centered
        className="custom-modal"
        destroyOnClose={true}
      >
        <Form>
          <Divider orientation="left">DateTime Input Name</Divider>
          <Form.Item
            label="DateTime input name"
            style={{ marginLeft: "50px" }}
            rules={[
              {
                required: true,
                message: "Date input datetime name is required",
              },
            ]}
          >
            <Input
              style={{ width: 360 }}
              placeholder="Please input datetime name"
              name="datetime"
              value={this.state.datetime.sectionname}
              onChange={this.handleModalValuesChange.bind(
                this,
                "datetimeinput",
                null
              )}
            />
          </Form.Item>
        </Form>
      </Modal>
    );
  }

  renderModelEmailInput() {
    return (
      <Modal
        visible={this.state.showEmailinputConfigModal}
        onOk={this.handleModalOk.bind(this, "emailinput")}
        onCancel={this.handleModalCancel.bind(this, "emailinput")}
        title={
          <span className="font-mont-b fs-16 c-blue text-uppercase">
            Config Email Input
          </span>
        }
        centered
        className="custom-modal"
        destroyOnClose={true}
      >
        <Form>
          <Divider orientation="left">Email Input Attribute</Divider>
          <Form.Item
            label="Email input name"
            style={{ marginLeft: "50px" }}
            rules={[
              { required: true, message: "Email input email name is required" },
            ]}
          >
            <Input
              style={{ width: 360 }}
              placeholder="Please input email name"
              name="email"
              value={this.state.emailinputFormData.sectionname}
              onChange={this.handleModalValuesChange.bind(
                this,
                "emailinput",
                null
              )}
            />
          </Form.Item>
        </Form>
        <Form>
          <Divider orientation="left">Email Input Max Length</Divider>
          <Form.Item
            label="Email input max length"
            style={{ marginLeft: "50px" }}
            rules={[
              {
                required: true,
                message: "Email input email max length is required",
              },
            ]}
          >
            <Input
              style={{ width: 360 }}
              placeholder="Please input email max length"
              name="emailmaxlength"
              value={this.state.emailinputFormData.sectionname}
              onChange={this.handleModalValuesChange.bind(
                this,
                "emailinput",
                null
              )}
            />
          </Form.Item>
        </Form>
      </Modal>
    );
  }

  renderModelMonthInput() {
    return (
      <Modal
        visible={this.state.showMonthinputConfigModal}
        onOk={this.handleModalOk.bind(this, "monthinput")}
        onCancel={this.handleModalCancel.bind(this, "monthinput")}
        title={
          <span className="font-mont-b fs-16 c-blue text-uppercase">
            Config Month Input
          </span>
        }
        centered
        className="custom-modal"
        destroyOnClose={true}
      >
        <Form>
          <Divider orientation="left">Month Input Name</Divider>
          <Form.Item
            label="Month input name"
            style={{ marginLeft: "50px" }}
            rules={[
              { required: true, message: "Month input month name is required" },
            ]}
          >
            <Input
              style={{ width: 360 }}
              placeholder="Please input month name"
              name="monthname"
              value={this.state.monthinputFormData.sectionname}
              onChange={this.handleModalValuesChange.bind(
                this,
                "monthinput",
                null
              )}
            />
          </Form.Item>
        </Form>
      </Modal>
    );
  }

  renderModelNumberInput() {
    return (
      <Modal
        visible={this.state.showNumberinputConfigModal}
        onOk={this.handleModalOk.bind(this, "numberinput")}
        onCancel={this.handleModalCancel.bind(this, "numberinput")}
        title={
          <span className="font-mont-b fs-16 c-blue text-uppercase">
            Config Month Input
          </span>
        }
        centered
        className="custom-modal"
        destroyOnClose={true}
      >
        <Form>
          <Divider orientation="left">Number Input Name</Divider>
          <Form.Item
            label="Number input name"
            style={{ marginLeft: "50px" }}
            rules={[
              {
                required: true,
                message: "Number input number name is required",
              },
            ]}
          >
            <Input
              style={{ width: 360 }}
              placeholder="Please input number name"
              name="numbername"
              value={this.state.numberinputFormData.sectionname}
              onChange={this.handleModalValuesChange.bind(
                this,
                "numberinput",
                null
              )}
            />
          </Form.Item>
        </Form>
      </Modal>
    );
  }

  renderModelRangeInput() {
    return (
      <Modal
        visible={this.state.showRangeinputConfigModal}
        onOk={this.handleModalOk.bind(this, "rangeinput")}
        onCancel={this.handleModalCancel.bind(this, "rangeinput")}
        title={
          <span className="font-mont-b fs-16 c-blue text-uppercase">
            Config Range Input
          </span>
        }
        centered
        className="custom-modal"
        destroyOnClose={true}
      >
        <Form>
          <Divider orientation="left">Range Input Name</Divider>
          <Form.Item
            label="Range input name"
            style={{ marginLeft: "50px" }}
            rules={[
              { required: true, message: "Range input range name is required" },
            ]}
          >
            <Input
              style={{ width: 360 }}
              placeholder="Please input range name"
              name="rangename"
              value={this.state.rangeinputFormData.sectionname}
              onChange={this.handleModalValuesChange.bind(
                this,
                "rangeinput",
                null
              )}
            />
          </Form.Item>
        </Form>
      </Modal>
    );
  }

  renderModelTelinput() {
    return (
      <Modal
        visible={this.state.showPhoneNumberinputConfigModal}
        onOk={this.handleModalOk.bind(this, "telinput")}
        onCancel={this.handleModalCancel.bind(this, "telinput")}
        title={
          <span className="font-mont-b fs-16 c-blue text-uppercase">
            Config Phone Number Input
          </span>
        }
        centered
        className="custom-modal"
        destroyOnClose={true}
      >
        <Form>
          <Divider orientation="left">Phone Number Input Name</Divider>
          <Form.Item
            label="Phone Number input name"
            style={{ marginLeft: "50px" }}
            rules={[
              {
                required: true,
                message: "Phone Number input phone number name is required",
              },
            ]}
          >
            <Input
              style={{ width: 360 }}
              placeholder="Please input phone number name"
              name="telname"
              value={this.state.telinputFormData.sectionname}
              onChange={this.handleModalValuesChange.bind(
                this,
                "telinput",
                null
              )}
            />
          </Form.Item>
        </Form>
      </Modal>
    );
  }

  renderModelTimeinput() {
    return (
      <Modal
        visible={this.state.showTimeinputConfigModal}
        onOk={this.handleModalOk.bind(this, "timeinput")}
        onCancel={this.handleModalCancel.bind(this, "timeinput")}
        title={
          <span className="font-mont-b fs-16 c-blue text-uppercase">
            Config Time Input
          </span>
        }
        centered
        className="custom-modal"
        destroyOnClose={true}
      >
        <Form>
          <Divider orientation="left">Time Input Name</Divider>
          <Form.Item
            label="Time input name"
            style={{ marginLeft: "50px" }}
            rules={[
              { required: true, message: "Time input time name is required" },
            ]}
          >
            <Input
              style={{ width: 360 }}
              placeholder="Please input time name"
              name="timename"
              value={this.state.timeinputFormData.sectionname}
              onChange={this.handleModalValuesChange.bind(
                this,
                "timeinput",
                null
              )}
            />
          </Form.Item>
        </Form>
      </Modal>
    );
  }

  renderModelUrlinput() {
    return (
      <Modal
        visible={this.state.showUrlinputConfigModal}
        onOk={this.handleModalOk.bind(this, "urlinput")}
        onCancel={this.handleModalCancel.bind(this, "urlinput")}
        title={
          <span className="font-mont-b fs-16 c-blue text-uppercase">
            Config Url Input
          </span>
        }
        centered
        className="custom-modal"
        destroyOnClose={true}
      >
        <Form>
          <Divider orientation="left">Url Input Name</Divider>
          <Form.Item
            label="Url input name"
            style={{ marginLeft: "50px" }}
            rules={[
              { required: true, message: "Url input url name is required" },
            ]}
          >
            <Input
              style={{ width: 360 }}
              placeholder="Please input url name"
              name="urlname"
              value={this.state.urlinputFormData.sectionname}
              onChange={this.handleModalValuesChange.bind(
                this,
                "urlinput",
                null
              )}
            />
          </Form.Item>
          <Form.Item
            label="Url input max length"
            style={{ marginLeft: "50px" }}
            rules={[
              { required: true, message: "Url input url max length is required" },
            ]}
          >
            <Input
              style={{ width: 360 }}
              placeholder="Please input url max length"
              name="urlmaxlength"
              value={this.state.urlinputFormData.sectionname}
              onChange={this.handleModalValuesChange.bind(
                this,
                "urlinput",
                null
              )}
            />
          </Form.Item>
        </Form>
      </Modal>
    );
  }

  renderModelWeekinput() {
    return (
      <Modal
        visible={this.state.showWeekinputConfigModal}
        onOk={this.handleModalOk.bind(this, "weekinput")}
        onCancel={this.handleModalCancel.bind(this, "weekinput")}
        title={
          <span className="font-mont-b fs-16 c-blue text-uppercase">
            Config Week Input
          </span>
        }
        centered
        className="custom-modal"
        destroyOnClose={true}
      >
        <Form>
          <Divider orientation="left">Week Input Name</Divider>
          <Form.Item
            label="Week input name"
            style={{ marginLeft: "50px" }}
            rules={[
              { required: true, message: "Week input week name is required" },
            ]}
          >
            <Input
              style={{ width: 360 }}
              placeholder="Please input week name"
              name="weekname"
              value={this.state.textinputFormData.sectionname}
              onChange={this.handleModalValuesChange.bind(
                this,
                "weekinput",
                null
              )}
            />
          </Form.Item>
        </Form>
      </Modal>
    );
  }

  renderModelTextAreaInput() {
    return (
      <Modal
        visible={this.state.showTextAreainputConfigModal}
        onOk={this.handleModalOk.bind(this, "textareainput")}
        onCancel={this.handleModalCancel.bind(this, "textareainput")}
        title={
          <span className="font-mont-b fs-16 c-blue text-uppercase">
            Config TextArea Input
          </span>
        }
        centered
        className="custom-modal"
        destroyOnClose={true}
      >
        <Form>
          <Divider orientation="left">TextArea Input Parameter</Divider>
          <Form.Item
            label="TextArea input name"
            style={{ marginLeft: "50px" }}
            rules={[
              {
                required: true,
                message: "TextArea input textarea name is required",
              },
            ]}
          >
            <Input
              style={{ width: 360 }}
              placeholder="Please input textarea name"
              name="textarea"
              value={this.state.textareainputFormData.sectionname}
              onChange={this.handleModalValuesChange.bind(
                this,
                "textareainput",
                null
              )}
            />
          </Form.Item>
          <Form.Item
            label="TextArea input columns"
            style={{ marginLeft: "50px" }}
            rules={[
              {
                required: true,
                message: "TextArea input textarea columns is required",
              },
            ]}
          >
            <Input
              style={{ width: 360 }}
              placeholder="Please input textarea columns"
              name="textareacolumns"
              value={this.state.textareainputFormData.sectionname}
              onChange={this.handleModalValuesChange.bind(
                this,
                "textareainput",
                null
              )}
            />
          </Form.Item>
          <Form.Item
            label="TextArea input textarea rows"
            style={{ marginLeft: "50px" }}
            rules={[
              {
                required: true,
                message: "TextArea input textarea rows is required",
              },
            ]}
          >
            <Input
              style={{ width: 360 }}
              placeholder="Please input textarea rows"
              name="textarearows"
              value={this.state.textareainputFormData.sectionname}
              onChange={this.handleModalValuesChange.bind(
                this,
                "textareainput",
                null
              )}
            />
          </Form.Item>
          <Form.Item
            label="TextArea input max length"
            style={{ marginLeft: "50px" }}
            rules={[
              {
                required: true,
                message: "Range input textarea max length is required",
              },
            ]}
          >
            <Input
              style={{ width: 360 }}
              placeholder="Please input textarea max length"
              name="textareamaxlength"
              value={this.state.textareainputFormData.sectionname}
              onChange={this.handleModalValuesChange.bind(
                this,
                "textareainput",
                null
              )}
            />
          </Form.Item>
        </Form>
      </Modal>
    );
  }

  /*  add table section */
  component_table(index, arr, data) {
    const { valueMasterLanguage } = this.state;
    return (
      <div
        key={`div_${index}`}
        style={{
          paddingTop: "10px",
          marginTop: "10px",
          borderBottom: "1px solid #F2F4F6",
        }}
      >
        <Input.Group fieldKey={[index, `group_${index}`]} compact>
          {valueMasterLanguage.map((value, key) => {
            console.log("key : " + key);
            console.log(
              "lang key : " +
                arr[index].language[key].key +
                " ,lang text : " +
                arr[index].language[key].text
            );
            const set_val =
              arr[index].language[key].key === value.key
                ? arr[index].language[key].text
                : "";
            return (
              <Form.Item
                name={[index, `label_name_${value.key}`]}
                fieldKey={[index, `label_name_${value.key}`]}
                rules={[
                  {
                    required: true,
                    message: `Label name (${value.key}) is required`,
                  },
                ]}
                key={`label_name_${value.key}_${index}`}
                label={`Label name (${value.key})`}
              >
                <Input
                  type="text"
                  defaultValue={set_val}
                  className="inputfile"
                  placeholder={`Please input label name (${value.key})`}
                  style={{
                    width: 210,
                    color: "#000f9f",
                  }}
                  onChange={(e) => {
                    this.updateComponent(e.target.value, index, key);
                  }}
                />
              </Form.Item>
            );
          })}
          {index === data - 1 && index !== 0 ? (
            <MinusCircleOutlined
              style={{ marginLeft: 13, marginTop: 9 }}
              key={`del_${index}`}
              onClick={() => {
                this.deleteColumn(index, arr);
              }}
            />
          ) : (
            ""
          )}
        </Input.Group>
      </div>
    );
  }

  updateComponent(text, index, key) {
    const {
      arr_modal,
      count_component,
      arr_backup,
      arr_modal_backup,
    } = this.state;
    console.log("text : " + text + " , index : " + index + " ,key : " + key);
    var cloneComp = JSON.parse(JSON.stringify(this.state)).count_component; // clone

    // console.log('arr_modal_backup')
    // console.log(arr_modal_backup)

    console.log("be arr_modal");
    console.log(arr_modal);

    var cloneArrModal = JSON.parse(JSON.stringify(this.state)).arr_modal; // clone
    // console.log('be cloneArrModal')
    // console.log(cloneArrModal)

    cloneArrModal[index].language.map((value, k) => {
      // console.log('k')
      // console.log(k)
      // console.log('value')
      // console.log(value)
      if (k === key) {
        value.text = text;
      }
    });
    console.log("af cloneArrModal");
    console.log(cloneArrModal);

    //cloneComp
    this.setState({
      arr_modal: cloneArrModal,
    });
    console.log("af arr_modal");
    console.log(arr_modal);
    console.log("count_component");
    console.log(count_component);
    // arr_modal[index].language[key].text = text
    // console.log('af arr_modal')
    // console.log(arr_modal)
    // console.log('count_component')
    // console.log(count_component)
    // console.log('arr_backup')
    // console.log(arr_backup)
  }

  onModalConfig(field, index) {
    const {
      count_component,
      config,
      count_modal,
      select_index,
      arr_modal,
      arr_backup,
      configCol,
    } = this.state;
    var cloneComp = JSON.parse(JSON.stringify(this.state)).count_component; // clone
    this.setState({
      arr_backup: cloneComp,
    });
    console.log("index : " + index);
    console.log(field);

    /** get key id */
    const modalKey = config[index].id;
    console.log("modalKey : " + modalKey);
    console.log("count_component");
    console.log(count_component);

    /** select item table in array */
    var data_modal = count_component.filter((item) => item.id === modalKey); //get item where id == key
    var current_lang = data_modal[0].component[0].language.length;

    /** gen new array language */
    if (configCol.length > current_lang) {
      //add new language
      var result = configCol.filter(function (o1) {
        return !data_modal[0].component[0].language.some(function (o2) {
          return o1.key === o2.key; // assumes unique id
        });
      });

      count_component.map((value_comp, i) => {
        value_comp.component.map((value_lang, index) => {
          // console.log("value_lang i : " + i + " , index : " + index);
          // console.log(value_lang);
          result.map((res, count) => {
            value_lang.language.push(res);
          });
        });
      });
    } else if (configCol.length < current_lang) {
      count_component.map((value_comp, i) => {
        value_comp.component.map((value_lang, index) => {
          var result = value_lang.language.filter(function (o1) {
            return configCol.some(function (o2) {
              return o1.key === o2.key; // intersect unique id
            });
          });
          value_lang.language = result;
        });
      });
    } else {
      count_component.map((value_comp, i) => {
        value_comp.component.map((value_lang, index) => {
          var newArr = [];

          /** intersect */
          var result_intersect = value_lang.language.filter(function (o1) {
            return configCol.some(function (o2) {
              return o1.key === o2.key; // intersect unique id
            });
          });

          newArr = result_intersect;

          /** new lang to push */
          var result = configCol.filter(function (o1) {
            return !value_lang.language.some(function (o2) {
              return o1.key === o2.key; // assumes unique id
            });
          });

          result.map((res, count) => {
            newArr.push(res);
          });
          value_lang.language = newArr;
        });
      });
    }

    this.setState({
      visibleConfig: true,
      count_modal: data_modal[0].value,
      select_index: modalKey,
      arr_modal: data_modal[0].component,
    });
  }

  addComponent() {
    const new_count = parseInt(this.state.count_form) + 1;
    this.state.config.push({ id: new_count, value: false });
    this.setState({ count_form: new_count });
  }

  removeComponent(i, field) {
    const { count_component, config } = this.state;
    /** update config */
    const newList = config.filter((item, j) => j !== i);
    this.setState({ config: newList });

    /**
     * update component
     * if exist array >> remove item from array
     **/
    var data_res = count_component.filter((item) => item.id === field.key);
    if (data_res !== undefined || data_res.length != 0) {
      const newList = count_component.filter(
        (item, j) => item.id !== field.key
      );
      this.setState({ count_component: newList });
    }
  }

  async onModalView(key, visibleView) {
    const result = await Api.get("get_mas_form_json", key);
    if (result.data.result.code === "P") {
      const data = result["data"]["data"]["mas_form_json_dto_list"];
      if (data.length > 0) {
        const dataMasFormJson = data[0];
        if (
          dataMasFormJson["expire_date"] !== "" &&
          dataMasFormJson["expire_date"] !== null
        ) {
          dataMasFormJson["expire_date"] = moment(
            dataMasFormJson["expire_date"],
            "YYYY/MM/DD"
          );
        }
        dataMasFormJson["condition"] = this.setConditions(
          dataMasFormJson["data_roles"]
        );
        dataMasFormJson["forms"] = this.setFormsView(dataMasFormJson);
        dataMasFormJson["language_name"] = dataMasFormJson[
          "language_name"
        ].split(",");
        dataMasFormJson["language"] = dataMasFormJson["language"].split(",");
        var myJSONString = JSON.parse(
          JSON.stringify(dataMasFormJson.form_json)
        );
        var setJson = JSON.parse(myJSONString);
        if (setJson[dataMasFormJson.table_name][0]["table"] !== undefined) {
          var pushtable = [];

          console.log("dataMasFormJson.table_name");
          console.log(dataMasFormJson.table_name);
          for (let i in setJson[dataMasFormJson.table_name]) {
            pushtable.push({
              title: setJson[dataMasFormJson.table_name][i].table.name,
              dataIndex: [i],
            });
          }
          this.setState({ TableColumnName: pushtable });
        }
        this.setState(
          {
            dataMasFormJson,
          },
          () => {
            this.setState({ visibleView });
          }
        );
      } else {
        this.setState({ visibleView });
      }
    }
  }

  operation(list1, list2, isUnion) {
    var result = [];

    for (var i = 0; i < list1.length; i++) {
      var item1 = list1[i],
        found = false;
      for (var j = 0; j < list2.length && !found; j++) {
        found = item1.key === list2[j].key;
      }
      if (found === !isUnion) {
        // isUnion is coerced to boolean
        result.push(item1);
      }
    }
    return result;
  }

  updateLang() {
    const { count_component, configCol } = this.state;
    /** check & update text */
    var cloneComp = JSON.parse(JSON.stringify(this.state)).count_component; // clone
    var cloneConfigCol = JSON.parse(JSON.stringify(this.state)).configCol; // clone
    cloneComp.map((value, key) => {
      value.component.map((value_comp, key_comp) => {
        let arrGroup = [];
        let arrlang = [];

        if (value_comp.language.length < cloneConfigCol.length) {
          cloneConfigCol.map((val_conf, index_conf) => {
            value_comp.language.map((val_lang, index_lang) => {
              if (val_conf.key == val_lang.key) {
                val_conf.text = val_lang.text;
              }
            });
          });
          value_comp.language = cloneConfigCol;
        } else if (value_comp.language.length > cloneConfigCol.length) {
          const filterLangauge = this.operation(
            value_comp.language,
            cloneConfigCol,
            false
          );
          value_comp.language = filterLangauge;
        } else {
          /** count lang === count filterLangauge : ex case lang EN,TH >> config TH,LO */
          const filterLangauge = this.operation(
            value_comp.language,
            cloneConfigCol,
            false
          );

          if (cloneConfigCol.length != filterLangauge.length) {
            console.log("update lang");
          }
        }
      });
    });

    this.setState({
      count_component: cloneComp,
    });
  }

  handleChangeType(value, index, field) {
    const { rulesOpt, disOpt, count_component, configCol } = this.state;
    if (
      value[0] === "select" ||
      value[1] === "radio" ||
      value[1] === "checkbox"
    ) {
      /* default (fix) */
      /*  rulesOpt[`forms_${index}_option`] = false;
       disOpt[`forms_${index}_option`] = false; */
      rulesOpt[`forms_${index}_option`] = false;
      disOpt[`forms_${index}_option`] = true;
    } else {
      rulesOpt[`forms_${index}_option`] = false;
      disOpt[`forms_${index}_option`] = true;
    }
    const check = value.includes("table") ? true : false;
    var cloneConfig = JSON.parse(JSON.stringify(this.state)).config;

    if (check) {
      /** select type Table */
      cloneConfig[index].value = true;
      //console.log(cloneConfig,'cloneConfig');
      this.setState({
        config: cloneConfig,
      });

      if (count_component.length === 0) {
        /** empty in array */
        count_component.push({
          id: field.key,
          value: 1,
          component: [{ language: configCol }],
        });
      } else {
        /** check id in array */
        var data_res = count_component.filter((item) => item.id === field.key);
        if (data_res === undefined || data_res.length == 0) {
          // array empty or does not exist
          count_component.push({
            id: field.key,
            value: 1,
            component: [{ language: configCol }],
          });
        } else {
          //console.log("found in array");
        } //end else
      }

      this.updateLang();
    } else {
      cloneConfig[index].value = false;
      this.setState({
        config: cloneConfig,
      });

      /** if exist array >> remove item from array */
      var data_res = count_component.filter((item) => item.id === field.key);

      if (data_res !== undefined || data_res.length != 0) {
        /** found in array */
        const newList = count_component.filter(
          (item, j) => item.id !== field.key
        );
        this.setState({ count_component: newList }); //update new array
      }
    }

    this.setState({
      rulesOpt,
      disOpt,
    });
  }

  handleSearchTableName = async (value) => {
    if (value) {
      const result = await Api.get(
        "get_table_name",

        this.state.valueModuleName + "/" + value
      );
      if (result.data.result.code === "P") {
        const dataTableName = result["data"]["data"]["table_name_dto_list"];
        this.setState({ dataTableName });
      }
    } else {
      this.setState({ dataTableName: [] });
    }
  };

  handleChangeTableName = async (value) => {
    const result = await Api.get(
      "get_column_name",

      this.state.valueModuleName + "/" + value
    );
    if (result.data.result.code === "P") {
      const dataColumnName = result["data"]["data"]["column_name_dto_list"];
      this.setState({ dataColumnName });
    }
    this.setState({
      valueTableName: value,
      disBtn: false,
    });
  };

  handleSearchModuleName = async (value) => {
    if (value) {
      const result = await Api.get(
        "get_module_name",

        value
      );
      if (result.data.result.code === "P") {
        const dataModuleName = result["data"]["data"]["module_name_dto_list"];
        console.log("dataModuleName : ");
        console.log(dataModuleName);
        this.setState({ dataModuleName });
      }
    } else {
      this.setState({ dataModuleName: [] });
    }
  };

  handleChangeModuleName = (value) => {
    this.setState({
      valueModuleName: value,
      disInput: false,
    });
  };

  handleSearchCompanyName = (value) => {
    if (value) {
      const { dataCompanyName } = this.state;
      console.log("handleSearchCompanyName value : " + value);
      console.log("dataCompanyName : ");
      console.log(dataCompanyName);

      this.setState({ dataCompanyName });
    } else {
      this.setState({ dataCompanyName: [] });
    }
  };

  handleChangeCompanyName = (value) => {
    this.setState({
      valueCompanyName: value,
      disInput: false,
    });
  };

  handleChangeMasterLanguage = (key, value) => {
    const { configCol } = this.state;
    var new_conf = [];
    value.map((val, index) => {
      new_conf.push({ key: val.key, text: "" });
    });

    this.setState({
      valueMasterLanguage: value,
      configCol: new_conf,
    });
  };

  formatValue(table, data) {
    let dataVal = "";
    const len = data.length;
    if (data.length > 0) {
      dataVal = "{";
      data.map((val, index) => {
        const name = this.formatName(val.label_name_EN);
        dataVal += '"' + name + '":""';
        dataVal += len - 1 !== index ? "," : "";
      });
      dataVal += "}";
    } //end if
    return dataVal;
  }

  formatOutput(table, data) {
    const { valueMasterLanguage, count_component } = this.state;
    const dataOutput = {};
    if (data.length > 0) {
      const _data = {};
      const datajson = {};
      var arr = [];
      var component = {};

      let arr_col = [];
      arr_col = this.setColumns();

      data.map((val, index) => {
        const { flag_output } = this.state;
        const name = this.formatName(val.label_name_EN);
        const _label = {};
        valueMasterLanguage.map((lang, i) => {
          console.log(val);
          console.log("language : " + lang.key);
          _label[lang.key] = {};
          _label[lang.key].for = name;
          _label[lang.key].text = val[`label_name_${lang.key}`];
          //_label[lang.key].width = 12;
          _label[lang.key].width = 6;
        });
        _label["CSS"] = {};

        //set json
        let json_label = {};
        if (val.type[0] === "table") {
          const _table = {};
          valueMasterLanguage.map((lang, i) => {
            _table[lang.key] = {};
            _table[lang.key].columns = arr_col[flag_output][lang.key];
            //_table[lang.key].datasource
          });
          _table["CSS"] = {};

          json_label = { label: _label, table: _table };
          this.setState({
            flag_output: flag_output + 1,
          });
        } else {
          json_label = { label: _label };
        }
        arr.push(json_label);
      });

      dataOutput["table"] = table;
      dataOutput["config_output"] = arr;
      return dataOutput;
    } //end if
  }

  setColumns() {
    const { count_component } = this.state;
    // console.log('setColumns count_component')
    // console.log(count_component)

    let arr_col = [];

    //count_component[flag_output].component.map((_field,_i) => {
    count_component.map((_f, _count) => {
      arr_col[_count] = [];
      _f.component.map((_field, _i) => {
        _field.language.map((_lang, _index) => {
          let col = {};
          col = {
            key: _lang.text,
            title: _lang.text,
            dataIndex: _lang.text,
          };

          //arr_col[_count][_lang.key] = []
          if (!arr_col[_count][_lang.key]) {
            arr_col[_count][_lang.key] = [col];
          } else {
            arr_col[_count][_lang.key][_i] = col;
          }
        });
      });
    });

    // console.log('arr_col')
    // console.log(arr_col)

    return arr_col;
  }

  // formatJSON(data, index) {
  //   const { valueMasterLanguage , count_component , count_modal } = this.state;
  //   console.log("formatJSON index : " + index + " , data");
  //   console.log(data);
  //   let format_json = {};
  //   const dataFormat = {};
  //   for (let j in valueMasterLanguage) {
  //     const language = valueMasterLanguage[j];
  //     if (data[index].type[0] === "table") {
  //       console.log("get table index : "+index);
  //       format_json[language.key] = {}
  //       console.log("count_component")
  //       console.log(count_component)
  //       //format_json[language.key].columns
  //     }//end if
  //   }//end for
  //   format_json["CSS"] = {}

  //   return format_json;
  // }
  formatIdName = (obj) => {
    let idName = "";
    if (obj.type[0] === "input") {
      switch (obj.type[1]) {
        default:
          return this.formatName(obj[`label_name_EN`]);
        case "text":
          idName = this.state.textinputFormData.textname;
          break;
        case "radio":
          idName = this.state.radioFormData.radioname;
          break;
        case "checkbox":
          idName = this.state.checkboxFormData.checkboxname;
          break;
      }
    } else if (obj.type[0] === "select") {
      switch (obj.type[1]) {
        default:
          return this.formatName(obj[`label_name_EN`]);
        case "nomultiple":
          idName = this.state.selectorFormData.selectorname;
          break;
        case "multiple":
          idName = this.state.selectorFormData.selectorname;
          break;
        case "callapi":
          idName = this.state.apiFormData.apiname;
          break;
      }
    } else {
      idName = this.formatName(obj[`label_name_EN`]);
    }
    return idName;
  };

  formatData(table, data) {
    // console.log('formatData data : ')
    // console.log(data)
    const { valueMasterLanguage } = this.state;
    const dataForms = {};
    if (data.length > 0) {
      const _data = {};
      const datajson = {};
      for (let x in data) {
        //console.log('x : '+x+'data : '+data)
        /*  const name = this.formatName(data[x][`label_name_EN`]); */
        const name = this.formatName(data[x][`label_name_EN`]);
        const xx = data[x].type[0] === "textarea" ? 1 : 2;
        //_label.text = data[x].label_name;
        const _label = {};
        for (let j in valueMasterLanguage) {
          const language = valueMasterLanguage[j];
          _label[language.key] = {};
          _label[language.key].for = name;
          _label[language.key].text = data[x][`label_name_${language.key}`];
          _label[language.key].class = "";
        }
        _data.tag = data[x].type[0];
        _data.type = data[x].type[1];
        _data.id = name;
        _data.name = name;
        _data.class = "";
        _data.required = data[x].type[xx];
        if (data[x].type[0] === "select") {
          /* add logic select api */
          if (data[x].type[1] === "callapi") {
            _data.callapi = true;
            _data.multiple = false;
          } else if (data[x].type[1] === "nomultiple") {
            _data.callapi = false;
            _data.multiple = false;
          } else if (data[x].type[1] === "multiple") {
            _data.callapi = false;
            _data.multiple = true;
          }
        }

        // console.log("_label : "+_label)
        datajson[x] = {};
        datajson[x]["label"] = _label;
        datajson[x][_data.tag] = this.formatForm(_data, x);
        if (
          (data[x].type[0] === "select" ||
            data[x].type[1] === "radio" ||
            data[x].type[1] === "checkbox") &&
          data[x].option !== undefined
        ) {
          datajson[x]["option"] = this.formatOption(data[x].option);
        }
      }
      dataForms[table] = {};
      dataForms[table] = datajson;
    }
    return dataForms;
  }

  /* OptimizeFormatForm */
  formatForm = (data, index) => {
    console.log("use", data.type);
    const { count_component, count_modal, flag_table } = this.state;
    let form_json = {};
    if (data.type === "tel") {
      form_json = {
        type: "tel",
        id: data.id,
        name: data.name,
        pattern: "[0-9]{3}-[0-9]{2}-[0-9]{3}",
        class: data.class,
        required: data.required ? true : false,
      };
    } else if (data.type === "callapi") {
      form_json = {
        id: this.state.apiFormData.apiname,
        name: this.state.apiFormData.apiname,
        class: data.class,
        multiple: false,
        callapi: true,
        required: data.required ? true : false,
        data: this.state.apiFormData,
      };
    } else if (data.type === "nomultiple") {
      form_json = {
        id: this.state.selectorFormData.selectorname,
        name: this.state.selectorFormData.selectorname,
        class: data.class,
        multiple: false,
        callapi: false,
        required: data.required ? true : false,
        data: this.state.selectorFormData,
      };
    } else if (data.type === "multiple") {
      form_json = {
        id: this.state.selectorFormData.selectorname,
        name: this.state.selectorFormData.selectorname,
        class: data.class,
        multiple: true,
        callapi: false,
        required: data.required ? true : false,
        data: this.state.selectorFormData,
      };
    } else if (data.type === "textarea") {
      form_json = {
        id: data.id,
        name: data.name,
        class: data.class,
        row: 3,
        required: data.required ? true : false,
      };
    } else if (data.type === "table") {
      form_json = {
        type: data.type,
        id: data.id,
        name: data.name,
        class: data.class,
        required: data.required ? true : false,
        config: count_component[flag_table],
      };
      this.setState({
        flag_table: flag_table + 1,
      });
    } else if (data.type === "text") {
      form_json = {
        type: data.type,
        id: this.state.textinputFormData.textname,
        name: this.state.textinputFormData.textname,
        class: data.class,
        required: data.required ? true : false,
        data: this.state.textinputFormData,
      };
    } else if (data.type === "radio") {
      form_json = {
        type: data.type,
        id: this.state.radioFormData.radioname,
        name: this.state.radioFormData.radioname,
        class: data.class,
        required: data.required ? true : false,
        data: this.state.radioFormData,
      };
    } else if (data.type === "checkbox") {
      form_json = {
        type: data.type,
        id: this.state.checkboxFormData.checkboxname,
        name: this.state.checkboxFormData.checkboxname,
        class: data.class,
        required: data.required ? true : false,
        data: this.state.checkboxFormData,
      };
    } else {
      form_json = {
        type: data.type,
        id: data.id,
        name: data.name,
        class: data.class,
        required: data.required ? true : false,
      };
    }
    return form_json;
  };

  /* formatForm(data, index) {
    const { count_component, count_modal, flag_table } = this.state;
    console.log('formatForm data : ')
    console.log(data)
    console.log('formatForm count_component : ')
    console.log(count_component)
    console.log('formatForm index : '+index+' ,count_modal : '+count_modal)
    console.log(count_component[count_modal])

    let form_json = {};
    if (data.type === "tel") {
      form_json = {
        type: "tel",
        id: data.id,
        name: data.name,
        pattern: "[0-9]{3}-[0-9]{2}-[0-9]{3}",
        class: data.class,
        required: data.required ? true : false,
      };
    } else if (data.tag === "select") {
        if (data.callapi) {
          form_json ={
            id: data.id,
            name: data.name,
            class: data.class,
            multiple: false,
            callapi: true,
            required: data.required ? true : false,
            data: this.state.apiFormData
          }
        } else {
          form_json = {
            id: data.id,
            name: data.name,
            class: data.class,
            multiple: data.multiple ? true : false,
            callapi: false,
            required: data.required ? true : false,
            data: this.state.selectorFormData
          };
        };  
    } else if (data.tag === "textarea") {
      form_json = {
        id: data.id,
        name: data.name,
        class: data.class,
        row: 3,
        required: data.required ? true : false,
      };
    } else if (data.tag === "table") {
      console.log('table index : '+index+' , flag_table : '+flag_table)
      console.log(count_component[flag_table])
      form_json = {
        type: data.type,
        id: data.id,
        name: data.name,
        class: data.class,
        required: data.required ? true : false,
        config: count_component[flag_table],
      };
      this.setState({
        flag_table: flag_table + 1,
      });
    } else {
      form_json = {
        type: data.type,
        id: data.id,
        name: data.name,
        class: data.class,
        required: data.required ? true : false,
      };
    }
    return form_json;
  } */

  formatOption(data) {
    let option = data.split(",");
    let options = [];
    for (let i = 0; i < option.length; i++) {
      options.push({
        value: option[i],
        label: option[i],
      });
    }
    return options;
  }

  formatName(data) {
    return data.replace(" ", "_").toLowerCase();
  }

  setConditions(data) {
    let option = data.split(",");
    let options = [];
    for (let i = 0; i < option.length; i++) {
      let _option = option[i].split("=");
      options.push({
        column_name: _option[0],
        value: _option[1],
      });
    }
    return options;
  }
  setForms(data, language) {
    const form_json = [];
    const form_json_parse = JSON.parse(data["form_json"]);
    for (let x in form_json_parse[data["table_name"]]) {
      const data_label = form_json_parse[data["table_name"]][x];
      const format = {};
      for (let j in language) {
        format[`label_name_${language[j]}`] =
          data_label["label"][language[j]].text;
      }
      format.disabled = true;
      if (data_label["input"]) {
        const required = data_label["input"].required ? "required" : "";
        format.type = ["input", data_label["input"].type, required];
        if (
          data_label["input"].type === "radio" ||
          data_label["input"].type === "checkbox"
        ) {
          format.option = this.setOption(data_label["option"]);
        }
      } else if (data_label["select"]) {
        const multiple = data_label["select"].multiple ? "multiple" : "";
        const required = data_label["select"].required ? "required" : "";
        format.type = ["select", multiple, required];
        format.option = this.setOption(data_label["option"]);
      } else if (data_label["textarea"]) {
        const required = data_label["textarea"].required ? "required" : "";
        format.type = ["textarea", required];
      }
      form_json.push(format);
    }
    return form_json;
  }

  setFormsView(data) {
    const form_json = [];
    const form_json_parse = JSON.parse(data["form_json"]);
    for (let x in form_json_parse[data["table_name"]]) {
      form_json.push(form_json_parse[data["table_name"]][x]);
    }
    return form_json;
  }

  setOption(data) {
    let option = "";
    for (let i = 0; i < data.length; i++) {
      option = option ? `${option},${data[i].value}` : data[i].value;
    }
    return option;
  }
  handleDelete = (key) => {
    const dataSource = [...this.state.dataSource];
    this.setState({
      dataSource: dataSource.filter((item) => item.key !== key),
    });
  };

  addField = () => {
    console.log("addField");
    let arr = ["one", "two", "three"];
    // Inner Content
    let content = document.createElement("div");
    content.innerHTML = "Hello World";

    // Algorithm
    let res = arr.reverse().reduce((acc, item) => {
      let a = document.createElement("div");
      a.classList.add(item);
      a.appendChild(acc);
      return a;
    }, content);

    const myForm = document.getElementById("myForm");

    myForm.appendChild(res);
  };

  addColumn = () => {
    const {
      count_modal,
      count_component,
      arr_modal,
      configCol,
      select_index,
    } = this.state;
    let new_count = count_modal + 1;
    console.log("bef arr_modal");
    console.log(arr_modal);

    var cloneArrModal = JSON.parse(JSON.stringify(this.state)).arr_modal; // clone
    console.log("cloneArrModal");
    console.log(cloneArrModal);
    this.setState({
      arr_modal_backup: cloneArrModal,
    });

    console.log("configCol addColumn ");
    console.log(configCol);

    arr_modal.push({ language: configCol });

    console.log("af arr_modal");
    console.log(arr_modal);
    console.log("select_index : " + select_index);
    //count_component
    var cloneComp = JSON.parse(JSON.stringify(this.state)).count_component; // clone
    cloneComp.map((field, index) => {
      console.log("index : " + index);
      console.log(field);
      if (field.id === select_index) {
        //field.value = count_modal;
        field.component = arr_modal;
      }
    });

    this.setState({
      count_modal: new_count,
      count_component: cloneComp,
    });
  };

  deleteColumn = (index, arr) => {
    const {
      count_modal,
      count_component,
      select_index,
      arr_modal,
    } = this.state;
    let new_count = count_modal - 1;
    // console.log("del index : " + index);
    // console.log("config select_key : " + select_index);
    // console.log("arr");
    // console.log(arr);
    // console.log("arr_modal");
    // console.log(arr_modal);

    var cloneArrModal = JSON.parse(JSON.stringify(this.state)).arr_modal; // clone
    this.setState({
      arr_modal_backup: cloneArrModal,
    });

    //var new_arr = arr.filter((item) => item.id === modalKey);

    // var new_arr = arr.filter((item, j) => {
    //   console.log(item);
    //   return j !== index;
    // });

    var new_arr = arr_modal.filter((item, j) => {
      console.log(item);
      return j !== index;
    });

    console.log("new_arr");
    console.log(new_arr);

    var cloneComp = JSON.parse(JSON.stringify(this.state)).count_component; // clone
    cloneComp.map((field, index) => {
      console.log("index : " + index);
      console.log(field);
      if (field.id === select_index) {
        //field.value = count_modal;
        field.component = new_arr;
      }
    });

    this.setState({
      count_modal: new_count,
      count_component: cloneComp,
      arr_modal: new_arr,
      //arr_modal:new_arr
    });
  };

  renderAdd() {
    const {
      visible,
      dataModuleName,
      dataTableName,
      dataColumnName,
      dataMasterLanguage,
      valueTableName,
      valueModuleName,
      valueCompanyName,
      valueMasterLanguage,
      rulesOpt,
      disOpt,
      disBtn,
      disInput,
      mode,
      dataMasFormJson,
      dataAdd,
      config,
      dataCompanyName,
    } = this.state;
    return (
      <div>
        {visible ? (
          <div>
            <span className="font-mont-b fs-16 c-blue text-uppercase">
              {mode} {this.state.btnType.toUpperCase()}
            </span>
            {mode === "add" ? (
              <Form
                onFinish={(values) => this.handleSubmit(values)}
                layout="vertical"
                initialValues={dataAdd}
              >
                <div className="row">
                  <div className="col">
                    <Form.Item
                      name="schema"
                      label="Module name"
                      rules={[
                        { required: true, message: "Module name is required" },
                      ]}
                      wrapperCol={{ span: 24 }}
                    >
                      <Select
                        showSearch
                        value={valueModuleName}
                        placeholder="Search select module name"
                        style={this.props.style}
                        defaultActiveFirstOption={false}
                        showArrow={false}
                        filterOption={false}
                        onSearch={this.handleSearchModuleName}
                        onChange={this.handleChangeModuleName}
                        notFoundContent={null}
                      >
                        {dataModuleName.map((d) => (
                          <Option key={d.value}>{d.text}</Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </div>
                  <div className="col">
                    <Form.Item
                      name="company"
                      label="Company name"
                      rules={[
                        { required: true, message: "Company name is required" },
                      ]}
                      wrapperCol={{ span: 24 }}
                    >
                      <Select
                        showSearch
                        value={valueCompanyName}
                        placeholder="Search select company name"
                        style={this.props.style}
                        defaultActiveFirstOption={false}
                        showArrow={false}
                        filterOption={false}
                        onSearch={this.handleSearchCompanyName}
                        onChange={this.handleChangeCompanyName}
                        notFoundContent={null}
                      >
                        {dataCompanyName.map((d) => (
                          <Option key={d.value}>{d.text}</Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </div>
                  <div className="col">
                    <Form.Item
                      name="effective_date"
                      label="Effective date"
                      rules={[
                        {
                          type: "object",
                          required: true,
                          message: "Please select effective date!",
                        },
                      ]}
                    >
                      <DatePicker
                        format="DD/MM/YYYY"
                        style={{ width: 150, color: "#000f9f" }}
                      />
                    </Form.Item>
                  </div>
                  <div className="col">
                    <Form.Item
                      name="expire_date"
                      label="Expire date"
                      rules={[
                        {
                          type: "object",
                          required: false,
                          message: "Please select expire date!",
                        },
                      ]}
                    >
                      <DatePicker
                        format="DD/MM/YYYY"
                        style={{ width: 150, color: "#000f9f" }}
                      />
                    </Form.Item>
                  </div>
                </div>
                <div className="row">
                  <div className="col-4">
                    <Form.Item
                      name="table_name"
                      label="Table name"
                      rules={[
                        { required: true, message: "Table name is required" },
                      ]}
                      wrapperCol={{ span: 24 }}
                    >
                      <Select
                        showSearch
                        value={valueTableName}
                        placeholder="Search select table name"
                        style={this.props.style}
                        defaultActiveFirstOption={false}
                        showArrow={false}
                        filterOption={false}
                        onSearch={this.handleSearchTableName}
                        onChange={this.handleChangeTableName}
                        notFoundContent={null}
                        disabled={disInput}
                      >
                        {dataTableName.map((d) => (
                          <Option key={d.value}>{d.text}</Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </div>
                  <div className="col-7">
                    <Form.Item
                      name="language"
                      label="Language"
                      rules={[
                        { required: true, message: "Language is required" },
                      ]}
                      wrapperCol={{ span: 24 }}
                    >
                      <Select
                        mode="multiple"
                        placeholder="Please select language"
                        style={{ width: "100%" }}
                        onChange={this.handleChangeMasterLanguage}
                        maxTagCount={5}
                        defaultActiveFirstOption={false}
                      >
                        {dataMasterLanguage.map((d) => (
                          <Option key={d.value} value={d.text}>
                            {d.text} ({d.value})
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </div>
                </div>
                <div className="row">
                  <div className="col">
                    <Form.List name="condition">
                      {(fields, { add, remove }) => {
                        return (
                          <div>
                            <Form.Item style={{ marginBottom: 20 }}>
                              <Button
                                disabled={disBtn}
                                type="primary"
                                onClick={() => {
                                  add();
                                }}
                              >
                                Add Conditions
                              </Button>
                            </Form.Item>
                            {fields.map((field, index) => (
                              <div
                                key={field.key}
                                style={{ marginRight: index === 0 ? 45 : 13 }}
                                align="start"
                              >
                                <Input.Group
                                  fieldKey={[field.fieldKey, `group_${index}`]}
                                  compact
                                >
                                  <Form.Item
                                    {...field} // Array
                                    key={`column_name_${index}`}
                                    name={[field.name, "column_name"]}
                                    fieldKey={[field.fieldKey, "column_name"]}
                                    rules={[
                                      {
                                        required: true,
                                        message: "Column name is required",
                                      },
                                    ]}
                                    label={index === 0 ? "Column name" : ""}
                                  >
                                    <Select
                                      placeholder="Please select column name"
                                      style={{ width: 200 }}
                                      disabled={index === 0 ? disBtn : false}
                                    >
                                      {dataColumnName.map((d) => (
                                        <Option key={d.value}>{d.text}</Option>
                                      ))}
                                    </Select>
                                  </Form.Item>
                                  <Form.Item
                                    {...field}
                                    key={`value_${index}`}
                                    name={[field.name, "value"]}
                                    fieldKey={[field.fieldKey, "value"]}
                                    rules={[
                                      {
                                        required: true,
                                        message: "Value is required",
                                      },
                                    ]}
                                    label={index === 0 ? "Value" : ""}
                                  >
                                    <Input
                                      placeholder="Please input value"
                                      style={{ width: 200, color: "#000f9f" }}
                                      disabled={index === 0 ? disBtn : false}
                                    />
                                  </Form.Item>
                                  {index !== 0 ? (
                                    <MinusCircleOutlined
                                      style={{ marginLeft: 13, marginTop: 5 }}
                                      key={`delr_${index}`}
                                      onClick={() => {
                                        remove(field.name);
                                      }}
                                    />
                                  ) : null}
                                </Input.Group>
                              </div>
                            ))}
                          </div>
                        );
                      }}
                    </Form.List>
                  </div>
                </div>
                <div className="row">
                  <div className="col">
                    <Form.List name="forms">
                      {(fields, { add, remove }) => {
                        return (
                          <div>
                            <Form.Item style={{ marginBottom: 20 }}>
                              <Button
                                disabled={disBtn}
                                type="primary"
                                onClick={() => {
                                  this.addComponent();
                                  add();
                                  console.log("add");
                                }}
                              >
                                Add Forms
                              </Button>
                            </Form.Item>
                            {fields.map((field, index) => (
                              <div
                                key={`div_${index}`}
                                style={{
                                  paddingTop: index === 0 ? 0 : 24,
                                  borderBottom: "1px solid #F2F4F6",
                                }}
                              >
                                <Input.Group
                                  fieldKey={[field.fieldKey, `group_${index}`]}
                                  compact
                                >
                                  {valueMasterLanguage.map((value, key) => {
                                    return (
                                      <Form.Item
                                        {...field}
                                        name={[
                                          field.name,
                                          `label_name_${value.key}`,
                                        ]}
                                        fieldKey={[
                                          field.fieldKey,
                                          `label_name_${value.key}`,
                                        ]}
                                        rules={[
                                          {
                                            required: true,
                                            message: `Label name (${value.key}) is required`,
                                          },
                                        ]}
                                        key={`label_name_${value.key}_${index}`}
                                        label={`Label name (${value.key})`}
                                      >
                                        <Input
                                          placeholder={`Please input label name (${value.key})`}
                                          style={{
                                            width: 210,
                                            color: "#000f9f",
                                          }}
                                          disabled={
                                            index === 0 ? disBtn : false
                                          }
                                        />
                                      </Form.Item>
                                    );
                                  })}
                                  <Form.Item
                                    {...field}
                                    name={[field.name, "type"]}
                                    fieldKey={[field.fieldKey, "type"]}
                                    rules={[
                                      {
                                        required: true,
                                        message: "Type is required",
                                      },
                                    ]}
                                    key={`type_${index}`}
                                    label={`Type`}
                                  >
                                    <Cascader
                                      placeholder="Please select type"
                                      options={this.state.typeOpt}
                                      style={{ width: 300 }}
                                      onChange={(value) => {
                                        this.handleChangeType(
                                          value,
                                          index,
                                          field
                                        );

                                        /* check call modal */

                                        if (value[0] === "input") {
                                          this.toggleModalShow(value[1]);
                                        } else if (value[0] === "textarea") {
                                          this.toggleModalShow(value[0]);
                                        }
                                      }}
                                      disabled={index === 0 ? disBtn : false}
                                    />
                                  </Form.Item>
                                  <Form.Item
                                    {...field}
                                    name={[field.name, "option"]}
                                    fieldKey={[field.fieldKey, "option"]}
                                    rules={[
                                      {
                                        required:
                                          rulesOpt[`forms_${index}_option`] !==
                                          undefined
                                            ? rulesOpt[`forms_${index}_option`]
                                            : false,
                                        message: "Option is required",
                                      },
                                    ]}
                                    key={`option_${index}`}
                                    label={`Option`}
                                  >
                                    <Input
                                      disabled={
                                        disOpt[`forms_${index}_option`] !==
                                        undefined
                                          ? disOpt[`forms_${index}_option`]
                                          : true
                                      }
                                      placeholder="Please input option ex. 1,2,3"
                                      style={{ width: 330, color: "#000f9f" }}
                                    />
                                  </Form.Item>
                                  {config[index]["value"] ? (
                                    <div
                                      style={{
                                        paddingTop: 40,
                                        paddingLeft: 10,
                                      }}
                                    >
                                      <a
                                        href="#"
                                        onClick={() => {
                                          this.onModalConfig(field, index);
                                        }}
                                      >
                                        <img src={Api.absoluteUrl("/icon/add_job.svg")} />
                                      </a>
                                    </div>
                                  ) : (
                                    ""
                                  )}

                                  {index !== 0 ? (
                                    <MinusCircleOutlined
                                      style={{ marginLeft: 13, marginTop: 45 }}
                                      key={`del_${index}`}
                                      onClick={() => {
                                        this.removeComponent(index, field);
                                        remove(field.name);
                                      }}
                                    />
                                  ) : null}
                                </Input.Group>
                              </div>
                            ))}
                          </div>
                        );
                      }}
                    </Form.List>

                    {/* <Form.List name="genTable">
                    {(fields, { add, remove }) => {
                        return (
                          <div>
                            <Form.Item style={{ marginBottom: 20 }}>
                              <Button
                                // disabled={disBtn}  
                                type="primary"
                                onClick={() => {
                                  add();
                                }}
                                style={{ width: "15%" }}
                              >
                                Add Column of Table
                              </Button>
                            </Form.Item>

                            {fields.map((field, index) => (
                              <div
                                key={`div_${index}`}
                                style={{
                                  paddingTop: index === 0 ? 0 : 24,                                  
                                }}
                              >1234</div>
                            ))}


                          </div>
                            )
                    }}

                    </Form.List> */}
                  </div>
                </div>

                {/* <div className="row">
                  <div className="col">
                    <Form.List name="genTable">
                    {(fields, { add, remove }) => {
                        return (
                          <div>
                            <Form.Item style={{ marginBottom: 20 }}>
                              <Button
                                type="primary"
                                onClick={() => {
                                  add();
                                }}
                                style={{ width: "15%" }}
                              >
                                Add Table
                              </Button>
                            </Form.Item>
                          </div>
                            )
                    }}

                    </Form.List>
                  </div>
                </div> */}

                <Form.Item className="mb-0 text-center">
                  <div className="row">
                    <div className="col mt-2">
                      <button
                        type="reset"
                        onClick={() => this.setState({ visible: false })}
                        className="btn btn-secondary mr-3"
                      >
                        Cancel
                      </button>
                      <button className="btn btn-success">Add</button>
                    </div>
                  </div>
                </Form.Item>
              </Form>
            ) : (
              <Form
                onFinish={(values) => this.handleSubmit(values)}
                layout="vertical"
                initialValues={dataMasFormJson}
              >
                <div className="row">
                  <div className="col">
                    <Form.Item
                      name="module_name"
                      label="Module name"
                      rules={[
                        { required: true, message: "Module name is required" },
                      ]}
                      wrapperCol={{ span: 24 }}
                    >
                      <Input disabled style={{ color: "#000f9f" }} />
                    </Form.Item>
                  </div>
                  <div className="col">
                    <Form.Item
                      name="effective_date"
                      label="Effective date"
                      rules={[
                        {
                          required: true,
                          message: "Please select effective date!",
                        },
                      ]}
                    >
                      <Input
                        disabled
                        style={{ width: 200, color: "#000f9f" }}
                      />
                    </Form.Item>
                  </div>
                  <div className="col">
                    <Form.Item name="expire_date" label="Expire date">
                      <DatePicker format="DD/MM/YYYY" style={{ width: 200 }} />
                    </Form.Item>
                  </div>
                </div>
                <div className="row">
                  <div className="col-4">
                    <Form.Item
                      name="table_name"
                      label="Table name"
                      rules={[
                        { required: true, message: "Table name is required" },
                      ]}
                      wrapperCol={{ span: 24 }}
                    >
                      <Input disabled style={{ color: "#000f9f" }} />
                    </Form.Item>
                  </div>
                  <div className="col-7">
                    <Form.Item
                      name="language_name"
                      label="Language"
                      rules={[
                        { required: true, message: "Language is required" },
                      ]}
                      wrapperCol={{ span: 24 }}
                    >
                      <Select
                        mode="multiple"
                        style={{ width: "100%" }}
                        maxTagCount={5}
                        defaultActiveFirstOption={false}
                        disabled
                      >
                        {dataMasterLanguage.map((d) => (
                          <Option key={d.value} value={d.text}>
                            {d.text} ({d.value})
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </div>
                </div>
                <div className="row">
                  <div className="col">
                    <Form.List name="condition">
                      {(fields) => {
                        return (
                          <div>
                            <h6>Conditions</h6>
                            {fields.map((field, index) => (
                              <div
                                key={field.key}
                                style={{ marginRight: index === 0 ? 45 : 13 }}
                                align="start"
                              >
                                <Input.Group
                                  fieldKey={[field.fieldKey, `group_${index}`]}
                                  compact
                                >
                                  <Form.Item
                                    {...field}
                                    key={`column_name_${index}`}
                                    name={[field.name, "column_name"]}
                                    fieldKey={[field.fieldKey, "column_name"]}
                                    rules={[
                                      {
                                        required: true,
                                        message: "Column name is required",
                                      },
                                    ]}
                                    label={index === 0 ? "Column name" : ""}
                                  >
                                    <Input
                                      style={{ width: 200, color: "#000f9f" }}
                                      disabled
                                    />
                                  </Form.Item>
                                  <Form.Item
                                    {...field}
                                    key={`value_${index}`}
                                    name={[field.name, "value"]}
                                    fieldKey={[field.fieldKey, "value"]}
                                    rules={[
                                      {
                                        required: true,
                                        message: "Value is required",
                                      },
                                    ]}
                                    label={index === 0 ? "Value" : ""}
                                  >
                                    <Input
                                      style={{ width: 200, color: "#000f9f" }}
                                      disabled
                                    />
                                  </Form.Item>
                                </Input.Group>
                              </div>
                            ))}
                          </div>
                        );
                      }}
                    </Form.List>
                  </div>
                </div>
                <div className="row">
                  <div className="col">
                    <Form.List name="forms">
                      {(fields, { add, remove }) => {
                        return (
                          <div>
                            <Form.Item style={{ marginBottom: 20 }}>
                              <Button
                                type="primary"
                                onClick={() => {
                                  add();
                                }}
                                style={{ width: "15%" }}
                              >
                                Add Forms
                              </Button>
                            </Form.Item>
                            {fields.map((field, index) => (
                              <div
                                key={`div_${index}`}
                                style={{
                                  paddingTop: index === 0 ? 0 : 24,
                                  borderBottom: "1px solid #F2F4F6",
                                }}
                              >
                                <Input.Group
                                  fieldKey={[field.fieldKey, `group_${index}`]}
                                  compact
                                >
                                  {valueMasterLanguage.map((value, key) => {
                                    return (
                                      <Form.Item
                                        {...field}
                                        name={[
                                          field.name,
                                          `label_name_${value.key}`,
                                        ]}
                                        fieldKey={[
                                          field.fieldKey,
                                          `label_name_${value.key}`,
                                        ]}
                                        rules={[
                                          {
                                            required: true,
                                            message: `Label name (${value.key}) is required`,
                                          },
                                        ]}
                                        key={`label_name_${value.key}`}
                                        label={`Label name (${value.key})`}
                                      >
                                        <Input
                                          placeholder={`Please input label name (${value.key})`}
                                          style={{ width: 210 }}
                                        />
                                      </Form.Item>
                                    );
                                  })}
                                  <Form.Item
                                    {...field}
                                    name={[field.name, "type"]}
                                    fieldKey={[field.fieldKey, "type"]}
                                    rules={[
                                      {
                                        required: true,
                                        message: "Type is required",
                                      },
                                    ]}
                                    key={`type_${index}`}
                                    label={`Type`}
                                  >
                                    <Cascader
                                      placeholder="Please select type"
                                      options={this.state.typeOpt}
                                      style={{ width: 300 }}
                                      onChange={(value) =>
                                        this.handleChangeType(value, index)
                                      }
                                      disabled={
                                        dataMasFormJson["forms"][index] !==
                                        undefined
                                          ? dataMasFormJson["forms"][index]
                                              .disabled
                                          : false
                                      }
                                    />
                                  </Form.Item>
                                  <Form.Item
                                    {...field}
                                    name={[field.name, "option"]}
                                    fieldKey={[field.fieldKey, "option"]}
                                    rules={[
                                      {
                                        required:
                                          rulesOpt[`forms_${index}_option`] !==
                                          undefined
                                            ? rulesOpt[`forms_${index}_option`]
                                            : false,
                                        message: "Option is required",
                                      },
                                    ]}
                                    key={`option_${index}`}
                                    label={`Option`}
                                  >
                                    <Input
                                      disabled={
                                        disOpt[`forms_${index}_option`] !==
                                        undefined
                                          ? disOpt[`forms_${index}_option`]
                                          : true
                                      }
                                      placeholder="Please input option ex. 1,2,3"
                                      style={{ width: 330, color: "#000f9f" }}
                                    />
                                  </Form.Item>
                                  {dataMasFormJson["forms"][index] !==
                                  undefined ? null : (
                                    <MinusCircleOutlined
                                      style={{ marginLeft: 13, marginTop: 45 }}
                                      key={`del_${index}`}
                                      onClick={() => {
                                        remove(field.name);
                                      }}
                                    />
                                  )}
                                </Input.Group>
                              </div>
                            ))}
                          </div>
                        );
                      }}
                    </Form.List>
                  </div>
                </div>

                <Form.Item className="mb-0 text-center">
                  <button
                    type="reset"
                    onClick={() => this.setState({ visible: false })}
                    className="btn btn-secondary"
                  >
                    Cancel
                  </button>
                  <button className="btn btn-success">Save</button>
                </Form.Item>
              </Form>
            )}
          </div>
        ) : null}
      </div>
      // </Modal>
    );
  }

  renderView() {
    // const components = {
    //   body: {
    //     row: EditableRow,
    //     cell: EditableCell,
    //   },
    // };
    const { visibleView, dataMasFormJson } = this.state;
    const forms =
      dataMasFormJson.forms !== undefined ? dataMasFormJson.forms : [];
    const language =
      dataMasFormJson.language !== undefined ? dataMasFormJson.language : [];
    const language_name =
      dataMasFormJson.language_name !== undefined
        ? dataMasFormJson.language_name
        : [];
    console.log("dataMasFormJson");
    console.log(dataMasFormJson);
    return (
      <Modal
        title={
          <span className="font-mont-b fs-16 c-blue text-uppercase">
            View Form
          </span>
        }
        centered
        visible={visibleView}
        footer={null}
        closable={false}
        className="custom-modal"
        destroyOnClose={true}
      >
        {forms[0].table === undefined ? (
          <Tabs defaultActiveKey="0" style={{ backgroundColor: "#fff" }}>
            {language_name.map((value, key) => {
              const language_key = language[key];
              return (
                <TabPane type="card" tab={value} key={key}>
                  <div className="row justify-content-center">
                    <div className="col-8">
                      <Form layout="vertical">
                        {forms.map((field, index) => {
                          if (field.input !== undefined) {
                            if (field.input["type"] === "radio") {
                              return (
                                <Form.Item
                                  key={index}
                                  name={field.label["EN"]["for"]}
                                  label={field.label[language_key]["text"]}
                                  rules={[
                                    {
                                      required: field.input["required"],
                                      message: `${field.label["EN"]["text"]} is required`,
                                    },
                                  ]}
                                >
                                  <Radio.Group options={field.option} />
                                </Form.Item>
                              );
                            } else if (field.input["type"] === "checkbox") {
                              return (
                                <Form.Item
                                  key={index}
                                  name={field.label["EN"]["for"]}
                                  label={field.label[language_key]["text"]}
                                  rules={[
                                    {
                                      required: field.input["required"],
                                      message: `${field.label["EN"]["text"]} is required`,
                                    },
                                  ]}
                                >
                                  <Checkbox.Group options={field.option} />
                                </Form.Item>
                              );
                            } else if (field.input["type"] === "date") {
                              return (
                                <Form.Item
                                  key={index}
                                  name={field.label["EN"]["for"]}
                                  label={field.label[language_key]["text"]}
                                  rules={[
                                    {
                                      required: field.input["required"],
                                      message: `${field.label["EN"]["text"]} is required`,
                                    },
                                  ]}
                                >
                                  <DatePicker format="DD/MM/YYYY" />
                                </Form.Item>
                              );
                            } else if (
                              field.input["type"] === "datetime-local"
                            ) {
                              return (
                                <Form.Item
                                  key={index}
                                  name={field.label["EN"]["for"]}
                                  label={field.label[language_key]["text"]}
                                  rules={[
                                    {
                                      type: "object",
                                      required: field.input["required"],
                                      message: `${field.label["EN"]["text"]} is required`,
                                    },
                                  ]}
                                >
                                  <DatePicker
                                    showTime
                                    format="DD/MM/YYYY HH:mm:ss"
                                  />
                                </Form.Item>
                              );
                            } else if (field.input["type"] === "password") {
                              return (
                                <Form.Item
                                  key={index}
                                  name={field.label["EN"]["for"]}
                                  label={field.label[language_key]["text"]}
                                  rules={[
                                    {
                                      type: "object",
                                      required: field.input["required"],
                                      message: `${field.label["EN"]["text"]} is required`,
                                    },
                                  ]}
                                >
                                  <Input.Password
                                    placeholder={`Please input ${field.label[
                                      "EN"
                                    ]["text"].toLowerCase()}`}
                                  />
                                </Form.Item>
                              );
                            } else {
                              return (
                                <Form.Item
                                  key={index}
                                  name={field.label["EN"]["for"]}
                                  label={field.label[language_key]["text"]}
                                  rules={[
                                    {
                                      required: field.input["required"],
                                      message: `${field.label["EN"]["text"]} is required`,
                                    },
                                  ]}
                                >
                                  <Input
                                    type={field.input["type"]}
                                    className="font-mont-r fs-12"
                                    size="large"
                                    placeholder={`Please input ${field.label[
                                      "EN"
                                    ]["text"].toLowerCase()}`}
                                    pattern={
                                      field.input["pattern"] !== undefined
                                        ? field.input["pattern"]
                                        : ""
                                    }
                                  />
                                </Form.Item>
                              );
                            }
                          } else if (field.select !== undefined) {
                            const options = field.option.map((d) => (
                              <Option key={d.value}>{d.label}</Option>
                            ));
                            return (
                              <Form.Item
                                key={index}
                                name={field.label["EN"]["for"]}
                                label={field.label[language_key]["text"]}
                                rules={[
                                  {
                                    required: field.select["required"],
                                    message: `${field.select["text"]} is required`,
                                  },
                                ]}
                              >
                                <Select
                                  className="font-mont-r fs-12"
                                  size="large"
                                  placeholder={`Please select ${field.label[
                                    "EN"
                                  ]["text"].toLowerCase()}`}
                                >
                                  {options}
                                </Select>
                              </Form.Item>
                            );
                          } else if (field.textarea !== undefined) {
                            return (
                              <Form.Item
                                key={index}
                                name={field.label["EN"]["for"]}
                                label={field.label[language_key]["text"]}
                                rules={[
                                  {
                                    required: field.textarea["required"],
                                    message: `${field.textarea["text"]} is required`,
                                  },
                                ]}
                              >
                                <Input.TextArea />
                              </Form.Item>
                            );
                          } else if (field.table !== undefined) {
                            console.log("================================");
                            // console.log(forms);
                            console.log(field.table.name);
                            // console.log(index);
                            console.log("================================");
                            // field.table.map((item, i) =>  {

                            //   return <li key={i}>Test</li>
                            // })
                          }
                        })}
                      </Form>
                    </div>
                  </div>
                </TabPane>
              );
            })}
          </Tabs>
        ) : (
          <div>
            {console.log(this.state.TableColumnName)}
            <DynamicTable obj={this.state.TableColumnName} />
          </div>
        )}
        <Form.Item className="mb-0 text-center">
          <button
            type="reset"
            onClick={() => this.setState({ visibleView: false })}
            className="btn btn-secondary"
          >
            Cancel
          </button>
        </Form.Item>
      </Modal>
    );
  }

  render() {
    const { data, columns } = this.state;
    return (
      <div>
        {this.state.visible ? (
          <div>{this.state.visible ? this.renderAdd() : null}</div>
        ) : (
          <div>
            <h3 className="font-mont-sb fs-18 c-blue">Dynamic</h3>

            <div className="d-flex justify-content-between my-3">
              <Input.Search
                placeholder="Search"
                onSearch={(value, event) => this.getDataGetMasFormJson(value)}
                style={{ width: 200 }}
              />

              <div className="row">
                <div className="col">
                  <button
                    className="btn btn-warning mr-3"
                    onClick={() => this.onModal("", "add", true, "form")}
                  >
                    <img src={Api.absoluteUrl("/icon/plus.svg")} className="mr-2" />
                    Add Form
                  </button>

                  {/* <button
                    className="btn btn-warning"
                    onClick={() => this.onModal("", "add", true, "table")}
                  >
                    <img src="/icon/plus.svg" className="mr-2" />
            Add Table
          </button> */}
                </div>
              </div>
            </div>
            <Table columns={columns} dataSource={data} pagination={false} />
            {/* <DynamicOutput dataJSON={this.state.testJSON} lang={this.state.lang} /> */}
          </div>
        )}
        {this.state.visibleView ? this.renderView() : null}
        {this.state.visibleConfig ? this.renderModalConfig() : null}
        {this.state.showApiConfigModal ? this.renderModelAPI() : null}
        {this.state.showSelectConfigModal ? this.renderModelSelect() : null}
        {this.state.showCheckboxConfigModal ? this.renderModelCheckbox() : null}
        {this.state.showRadioConfigModal ? this.renderModelRadio() : null}
        {this.state.showTextinputConfigModal
          ? this.renderModelTextInput()
          : null}
        {this.state.showPasswordinputConfigModal
          ? this.renderModelPasswordInput()
          : null}
        {this.state.showDateinputConfigModal
          ? this.renderModelDateInput()
          : null}
        {this.state.showDateTimeinputConfigModal
          ? this.renderModelDateTimeInput()
          : null}
        {this.state.showEmailinputConfigModal
          ? this.renderModelEmailInput()
          : null}
        {this.state.showMonthinputConfigModal
          ? this.renderModelMonthInput()
          : null}
        {this.state.showNumberinputConfigModal
          ? this.renderModelNumberInput()
          : null}
        {this.state.showRangeinputConfigModal
          ? this.renderModelRangeInput()
          : null}
        {this.state.showPhoneNumberinputConfigModal
          ? this.renderModelTelinput()
          : null}
        {this.state.showTextAreainputConfigModal
          ? this.renderModelTextAreaInput()
          : null}
        {this.state.showTimeinputConfigModal
          ? this.renderModelTimeinput()
          : null}
        {this.state.showUrlinputConfigModal ? this.renderModelUrlinput() : null}
        {this.state.showWeekinputConfigModal
          ? this.renderModelWeekinput()
          : null}
      </div>
    );
  }
}
export default DynamicList;
